
<script>
import axios from 'axios';

import { supabase } from "../../libs/supabaseClient";

import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css';

import config from '../../libs/config.json';
import emojis from '../../libs/emojis.json';
import func from '../../libs/functions.js';

import _facebook from '../../libs/facebook';
import _twitter from '../../libs/twitter';
import _instagram from '../../libs/instagram';
import _youtube from '../../libs/youtube';
import _playstore from '../../libs/playStore';
import _appstore from '../../libs/appStore';
import _gmail from '../../libs/gmail';
import _email from '../../libs/email';
import _linkedIn from '../../libs/linkedin';
import _googlemybusiness from '../../libs/googleMyBusiness';
import _twilio from '../../libs/twilio';
import _trustpilot from '../../libs/trustpilot';

import _system from '../../libs/system'

import api from '../../api'
import _ from 'lodash'
import { mapGetters, mapActions } from "vuex";

import { _is } from './mixins/_is'
import { getPlatformImage } from './mixins/getPlatformImage'

import AOS from 'aos'
import 'aos/dist/aos.css'
import networks from '../../store/networks';
import workspaces from '../../libs/system/services/workspaces';
import twilio from '../../libs/twilio';


import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'



export default {
  name: "conversationModal",
  mixins: [_is, getPlatformImage],
  components: {
    quillEditor
  },
  props:{
    conversationId : {
      type: String
    },
    openedMessage : {
      type: Object
    }
  },
  data() {
    return {
      func: func,
      emojis: emojis,
      recentEmojis: [],
      polling: null,
      loadTakeoverBlurData: '',
      conversationOpenedDate: '',
      twitterDmButton: false,
      suggestedReply: '',
      writeNotePointer: false,
      takeover: {},
      agentTakeover: {},
      retrainModal: false,
      retrainModalAnswer: '',
      retrainModalAnswerCount: '',
      retrainModalQuestion: '',
      isShopify: false,
      contact: {
        name: '',
        email: '',
        phone: ''
      },
      visitedNow: [],
      matchedViewers: [],
      matchedViewer: {},
      meta: false,
      modalInside: false,
      modalInIn: "hidden",
      maxHeight: 0,
      loading: false,
      dbTags: ['Urgent', 'Feedback', 'Feature Request', 'Lead', 'Churn'],
      currentTags: ['Feedback'],
      tagSelector : false,
      currectScrollHeight:0,
      scrolled:false,
      searchEmojis: '',
      searchTags: '',
      cannedResponse:'',
      loadingComponent: {
        deleteFacebook: false,
        deleteInstagram: false,
      },
      loader: {
        sending: false,
        sendingFile: false,
        note: false,
        aiGenerating: false,
        typing: false,
        feed : true,
        typingName: '',
        addContact: false,
        error: ''
      },
      message: {},
      feed: {
        load: false,
        attachments: []
      },
      replyTo: {
        name: '',
        _id: '',
        avatar: '',
        text: '',
        data: {},
        type: ''
      },
      replyModal: {
        text: "",
        repliedMessage: { _id: "" }
      },
      attachmentPreview: '',
      attachmentPreviews: [],
      attachment: {},
      attachments: [],
      note: {
        text: ''
      },
      show: {
        seeAllMessages : false,
        sensitiveData: false,
        emojis: false,
        teamList: false,
        removeAssigned: false,
        setAssigned: false,
        quickReply: false,
        hoverResponseId: '',
        twitterDm: false,
        replies: false,
      },
       isLikingFacebook: false,
       isUnlikingFacebook: false,
       isLikingTwitter: false,
       isUnlikingTwitter: false,
       isHiding: false,
       isUnhiding: false
    };
  },
  computed: {
    ...mapGetters("session", ["isLoggedIn","getUser","getJwt", "getRole"]),
    ...mapGetters('contacts', ['contacts']),
    ...mapGetters('networks', ['networks', 'networksByName', 'networksById']),
    ...mapGetters('accounts', ['accounts', 'accountsByName', 'accountsByPId', 'accountsById', 'workspaceAccountsById']),
    ...mapGetters('statuses', ['statuses', 'statusesById', 'statusesByName']),
    ...mapGetters('workspaceusers', ['workspaceusers', 'workspaceusersById']),
    ...mapGetters('workspaces', ['currentWorkspace']),
    ...mapGetters('messages', ['messages', 'viewingMessages']),
    ...mapGetters('notifications', ['getNotificationNotes', 'getNotificationMessagesGroupedByPageId', 'getNotificationMessages']),
    ...mapGetters('tags', ['tagsByTypeName', 'tagsById', 'getEnumaratedTags', 'tagsByName']),
    ...mapGetters('htmlModals', ['modals']),
    loadTakeoverBlur(){
      setTimeout(() => {
        this.loadTakeoverBlurData = 'takeoverBlur';
      }, 500);
    },
    takeoverChecker(){
      //Supabase
      let matchedViewer = _.find(this.viewingMessages, { messageId: this.conversationId });
      this.matchedViewers = _.filter(this.viewingMessages, { messageId: this.conversationId });

      if(matchedViewer && this.conversationOpenedDate > matchedViewer.date){
        this.takeover = { state: true };
        this.matchedViewer = matchedViewer;
        return true
      }else if(matchedViewer && this.conversationOpenedDate < matchedViewer.date){
        if(!_.find(this.visitedNow, { 'user' : { _id: matchedViewer.user._id } })){
          this.visitedNow = this.matchedViewers
        }
        return false
      }else{
        this.visitedNow = [];
        return false
      }
    },
    agentTakeoverChecker(){
      let chatbotTag = this.tagsByName['Chatbot']._id

      if(_.includes(this.message.tags, chatbotTag)){
        this.agentTakeover = { state: true };
        return true
      }else{
        return false
      }
    },
    agentTookover(){
      let chatbotTag = this.tagsByName['Chatbot']._id
      let message = this.message
      let e = ''
      this.removeFromTags(e, chatbotTag, message)
      this.agentTakeover = { state: false };
    },
          editor() {
        return this.$refs.myQuillEditor.quill
      },
    getEmojis() {
      return this.emojis.filter(item => {
        return item.keywords.toLowerCase().indexOf(this.searchEmojis.toLowerCase()) > -1
      })
    },
    getCannedResponses() {
      return this.getCurrentWorkspaceuser().quickReplies.filter(item => {
        return item.text.toLowerCase().indexOf(this.cannedResponse.toLowerCase()) > -1
      })
    },
    assignableTeam() {

      if(this.getRole.name == 'Admin'){
        return this.workspaceusers;
      }

      let currentWorkspaceUser = _.find(this.workspaceusers, { 'user' : { '_id' :  this.getUser._id }});
      if(currentWorkspaceUser.visibleUsers && currentWorkspaceUser.visibleUsers.length){

        let filteredAssignedTeamMembers = _.filter(this.workspaceusers, (workspaceUser) => {
          if(_.find(currentWorkspaceUser.visibleUsers, { _id:  workspaceUser.user._id})){
            return workspaceUser;
          }
        })
        return filteredAssignedTeamMembers;
      }else{      
        return this.workspaceusers
      }
    }
  },
  watch: {
    getNotificationNotes(notes, oldValue) {
      if(notes.length && notes[0].messageId == this.message._id && notes[0].type == 'note'){

        //Check message is exist? if it's exist then return and stop function
        let exist = _.find(this.message.notes, { _id: notes[0]._id })
        if(exist) return;

        this.loader.typing = true;
        this.loader.typingName =  notes[0].user.name;

        setTimeout(() => {
          this.loader.typing = false;
          this.message.notes.push(notes[0]);
                setTimeout(() => {
                const notesWrapper = document.getElementById("notesWrapper");
                notesWrapper.scrollTop = notesWrapper.scrollHeight;
                }, 100)
        }, 1000)

      }
    },
    getNotificationMessages(data, oldValue) {
            //bunu her yerde kullanicaz ondan dolayi thislerin (data) içine taşı lütfen
      let objDiv = document.getElementById("overflow");
      let current = objDiv.scrollHeight;
      //console.log('#', data)
      if(data && data.length && data[0].fullDocument && (this.networksById[data[0].fullDocument.platform].name == 'Facebook' || this.networksById[data[0].fullDocument.platform].name == 'Instagram') && data[0].fullDocument.from.id == this.message.from.id){
        //console.log('1', this.message.replies);
        this.message.replies.push(data[0].fullDocument);

        this.scrollToSmoothly(objDiv.scrollHeight, objDiv, current);
        //console.log('2', this.message.replies);
      }

    }
  },
  methods: {
    ...mapActions("messages", ["setMessages"]),
    ...mapActions("message", ["setMessage"]),
    ...mapActions('tags', ['setTags', 'setPushTag']),
    ...mapActions("contacts", ["insertContact"]),
    ...mapActions("htmlModals", ["setConversationModal", "setCreateTag"]),
    record(event){
      if(event == 'start'){
        console.log('Start triggered.')
        console.log("recordButton clicked");


	/*
		Simple constraints object, for more advanced audio features see
		https://addpipe.com/blog/audio-constraints-getusermedia/
	*/

    window.juphyVoiceRecord = {}
    
    window.juphyVoiceRecord.constraints = { audio: true, video: false }

 	/*
    	Disable the record button until we get a success or fail from getUserMedia() 
	*/

/* 	recordButton.disabled = true;
	stopButton.disabled = false;
	pauseButton.disabled = false */

	/*
    	We're using the standard promise based getUserMedia() 
    	https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
	*/

	navigator.mediaDevices.getUserMedia(window.juphyVoiceRecord.constraints).then(function(stream) {
		console.log("getUserMedia() success, stream created, initializing Recorder.js ...");

		/*
			create an audio context after getUserMedia is called
			sampleRate might change after getUserMedia is called, like it does on macOS when recording through AirPods
			the sampleRate defaults to the one set in your OS for your playback device

		*/
		var audioContext = new AudioContext();

		//update the format 
		//document.getElementById("formats").innerHTML="Format: 1 channel pcm @ "+audioContext.sampleRate/1000+"kHz"

		/*  assign to gumStream for later use  */
		window.juphyVoiceRecord.gumStream = stream;
		
		/* use the stream */
		var input = audioContext.createMediaStreamSource(stream);

		/* 
			Create the Recorder object and configure to record mono sound (1 channel)
			Recording 2 channels  will double the file size
		*/
		window.juphyVoiceRecord.rec = new Recorder(input,{numChannels:1})

		//start the recording process
		window.juphyVoiceRecord.rec.record()

		console.log("Recording started");

    document.getElementById('recordButton').disabled = true;
    document.getElementById('stopButton').style.visibility = 'visible';

	}).catch(function(err) {
    console.log(err)
	  	//enable the record button if getUserMedia() fails
/*     	recordButton.disabled = false;
    	stopButton.disabled = true;
    	pauseButton.disabled = true */
	});

      }

      if(event == 'stop'){
        console.log('Stop triggered.')
        
        console.log("stopButton clicked");

          //disable the stop button, enable the record too allow for new recordings
/*           stopButton.disabled = true;
          recordButton.disabled = false;
          pauseButton.disabled = true; */

          //reset button just in case the recording is stopped while paused
         // pauseButton.innerHTML="Pause";

          //tell the recorder to stop the recording
          window.juphyVoiceRecord.rec.stop();

          //stop microphone access
          window.juphyVoiceRecord.gumStream.getAudioTracks()[0].stop();

          //create the wav blob and pass it on to createDownloadLink
          //let recordedBlob = window.juphyVoiceRecord.rec.exportWAV();
          window.juphyVoiceRecord.rec.exportWAV(createDownloadLink);

          function createDownloadLink(blob) {
            //console.log(blob)
            var url = URL.createObjectURL(blob);

            //15270342-a608-468c-acf1-1610f8b1bf9d


/*             const formData = new FormData();
            formData.append('audioBlob', new File([blob], 'audio.wav', { type: 'audio/x-wav' }));

              axios.post('http://127.0.0.1:5555/converter',
              formData ).then((response) => {

                  
                  }).catch((error) => {
                            console.log(error)
                  });

          return; */

            window.juphyVoiceRecord.audioFile = new File([blob], 'audio.wav', { type: 'audio/wav' });

            console.log(url);
            document.getElementById('voiceRecordElement').style.display = 'block';
            document.getElementById('voiceRecordElement').style.width = '100%';
            document.getElementById('voiceRecordElement').src = url;

            document.getElementById('stopButton').style.visibility = 'hidden';
            document.getElementById('recordButton').disabled = false;
          }

          //var url = URL.createObject ecordedBlob);

          //name of .wav file to use during upload and download (without extendion)
          //var filename = new Date().toISOString();

          //console.log(url)




      }
    },
     openSocial(message){
       if(message.platform == '5c0bcfb235563f46ca2921bd'){
          window.open(`https://www.facebook.com/${_.find( this.accounts, { _id: message.page }).id}`, '_blank') 
       }else if(message.platform == '5c0bcfb335563f46ca2921cb'){
          window.open(`https://www.instagram.com/${_.find( this.accounts, { _id: message.page }).screenName}`, '_blank') 
       } 
      },
    addUsernameTags(){
      if(this.getUser.email.includes('@wise') || this.getUser.email.includes('@juphy') || this.getUser.email.includes('@transferwise')){
                let clarifiedNewTag = this.getUser.email.match(/([^@]*)@/)[1]
                let payload = {
                  body:{
                    name:clarifiedNewTag,
                    typeName:  "MessageTag"
                  }
                }

                _system.services.tags.create(payload, (err, newTag) => {
                  if(err) return alert('Try again later!')
                  let payload = {
                    body: {
                        userTagId : newTag._id,
                        color: this.color
                    },
                    query: {
                        workspaceId: this.currentWorkspace._id
                    }
                  }
                 // console.log('THIS IS THE TAG', newTag)

                  _system.services.tags.addTagIntoCurrentWorkspace( payload,(err,newWorkspace)=>{
                     if(err) return alert('Try again later!');
                     this.setPushTag(newTag);
                     this.currentWorkspace.userTags = newWorkspace.userTags

                        this.tag = ""
                        this.addIntoTags('', newTag, this.message)
                  });
                });
              }
    },
    addIntoContacts(){

      this.contact.name = this.message.from.name;

      if(!this.contact.email.length && !this.contact.phone.length){
        alert('At least one contact information required.')
      }

      let platformName = this.networksById[this.message.platform].name

      let payload = [{
        name: this.contact.name,
        email: this.contact.email,
        phone: this.contact.phone,
        ws_id: this.currentWorkspace._id,
        conversation_id: this.message._id
      }]

      if(platformName == 'Instagram'){
        payload[0].instagram_id = this.message.from.name
      }else if(platformName == 'Facebook'){
        payload[0].facebook_id = this.message.from.id
      }
      

      supabase.from('contacts').upsert(payload, {
            onConflict: 'email',
            set: {
              phone: 'excluded.phone',
              name: 'excluded.name'
            },
          }).then(result => {
            console.log(result)
            this.insertContact(payload)
            // Handle successful insertion
               this.modals.upload = false;
               iziToast.success({
                  position: 'bottomCenter',
                  title:  'Contact successfully updated.'
               });
          })
          .catch(error => {
            // Handle insertion error
            console.error(error)
          });
    },
    replySuggestion(){

      let messages = [];
      let mainObject = {};

      mainObject.prompt = "The latest conversation between our support agent and our customer given below. What is the best next possoble answer? Please generate answer by statements above /n Statements; Support Agent working in Fintech company /n This message is a customer review /n Check the review's sentiment because sometimes customers may be angry /n Do not ask any question at the end of answer /n Try to be polite and very professsional and formal /n In the answer do not indicate or start with Agent: or Support Agent: /n so the review below:"

      if(this.message.replies && this.message.replies.length){
        messages = [{"role": " Customer: ", "content": this.message.text + " /n" }]
/*         messages = _.map(this.message.replies, (reply) => {

          mainObject.prompt = "The latest conversation between our support agent and our customer given below. What is the best next possoble answer? Please generate answer by statements above /n Statements; Support Agent working in Fintech company /n This message is a customer review /n Check the review's sentiment because sometimes customers may be angry /n Do not ask any question at the end of answer /n Try to be polite and very professsional and formal /n In the answer do not indicate or start with Agent: or Support Agent:"

          let object = [];
          if(this.accountsByPId[reply.from.id] || this.accountsById[reply.from.id]){
            object.role = " Support Agent: "
            object.content = reply.text + " /n"
          }else{
            object.role = " Customer: "
            object.content = reply.text + " /n"
          }

          return object
        }) */
      }else{
        messages = [{"role": " Customer: ", "content": this.message.text + " /n" }]
      }

      messages = messages.slice(-3);

      for (let index = 0; index < messages.length; index++) {
        const element = messages[index];

        mainObject.prompt = mainObject.prompt + element.role + element.content
        
      }

      this.loader.aiGenerating = true;

      axios.post('https://api.openai.com/v1/completions',
      {
        "model": "text-davinci-003",
        "max_tokens": 500,
        "prompt": mainObject.prompt
      },
        {
        headers: {
          Authorization: 'Bearer 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'
        }
        }).then((response) => {

          this.suggestedReply = response.data.choices[0].text.replace(/\n/g, "");

          this.loader.aiGenerating = false;
          
                  }).catch((error) => {
                  if (error.response) {
                    this.loader.aiGenerating = false;
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      
                      //this.$router.push({ "path": "signin" });
                      // console.log(error.response.status);
                      // console.log(error.response.headers);
                  } else if (error.request) {
                    this.loader.aiGenerating = false;
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      //this.$router.push({ "path": "signin" });
                      
                  }
          });



    },
    downloadAttachment(file){},
    onEditorBlur(quill) {
        console.log('editor blur!', quill)
      },
      onEditorFocus(quill) {
        console.log('editor focus!', quill)
      },
      onEditorReady(quill) {
        console.log('editor ready!', quill)
      },
      onEditorChange({ quill, html, text }) {
        console.log('editor change!', quill, html, text)
        this.content = html
      },
    checkImg(item){
      if(!item.from.avatar && this.accountsByPId[item.from.id]) {
        return this.accountsByPId[item.from.id].avatar
      }else if(this.networksById[item.platform].name == 'Google My Business' && !item.from.avatar){
        return this.accountsByName[item.from.name].avatar
      }else{
        return item.from.avatar
      }
    },
    checkLinkedInCommentIsLiked(message){
      if(message.liked && message.liked.users){
        if(_.find(message.liked.users, { id:  (this.workspaceAccountsById[this.message.page] && this.workspaceAccountsById[this.message.page].id) ? this.workspaceAccountsById[this.message.page].id : this.workspaceAccountsById[this.message.page._id].id   })) {
          return true;
        }else{
          return false;
        } 
      }else{
        return false;
      }
    },
    checkFacebookCommentIsLiked(message){
      if(message.liked && message.liked.users){
        if(_.find(message.liked.users, { id:  (this.workspaceAccountsById[this.message.page] && this.workspaceAccountsById[this.message.page].id) ? this.workspaceAccountsById[this.message.page].id : this.workspaceAccountsById[this.message.page._id].id   })) {
          return true;
        }else{
          return false;
        } 
      }else{
        return false;
      }
    },
    checkTweetIsLiked(message){
      if(message.liked && message.liked.users){
        if(_.find(message.liked.users, { id:  (this.workspaceAccountsById[this.message.page] && this.workspaceAccountsById[this.message.page].id) ? this.workspaceAccountsById[this.message.page].id : this.workspaceAccountsById[this.message.page._id].id   })) {
          return true;
        }else{
          return false;
        } 
      }else{
        return false;
      }
    },
    checkTweetIsReTweeted(message){
      if(message.retweeted && message.retweeted.users){
        if(_.find(message.retweeted.users, { id:  (this.workspaceAccountsById[this.message.page] && this.workspaceAccountsById[this.message.page].id) ? this.workspaceAccountsById[this.message.page].id : this.workspaceAccountsById[this.message.page._id].id   })) {
          return true;
        }else{
          return false;
        } 
      }else{
        return false;
      }
    },
    updateReplyTo(name,_id,avatar, text, data, type){
      //text undefined
      this.replyTo.name = name;
      this.replyTo._id = _id;
      this.replyTo.avatar = avatar;
      this.replyTo.text = (text)? text : ''
      this.replyTo.data = data;
      this.replyTo.type = type;
      var objDiv = document.getElementById("scrollingContainer");
      objDiv.scrollTop = objDiv.scrollHeight;
      document.getElementById("replyBox").focus();

    },
    truspilotReviewReply(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      let objDiv = document.getElementById("overflow");

      if(objDiv){
        var current = objDiv.scrollHeight;
      }

    this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        let payload = {
          query: {
            conversationId: this.message._id
          },
          body: {
            text: this.replyModal.text
          }
        }

          _trustpilot.api.review.reply(payload, (err, newMessage) => {
            if(err) return alert(err.data.message);
              this.replyModal.text = "";
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage

              this.loader.sending = false;       

              if(objDiv){
                this.scrollToSmoothly(objDiv.scrollHeight, objDiv, current);
              }
              
              this.addUsernameTags()
              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              }             
            })
          })
      },
    whatsAppReply(_id, status){
      if((!this.replyModal.text || !this.replyModal.text.length) && !this.attachmentPreview.length) return alert('Input cannot be empty!');
      this.loader.sending = true;

      let objDiv = document.getElementById("overflow");

      if(objDiv){
        var current = objDiv.scrollHeight;
      }

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        this.replyModal.repliedMessage._id = this.replyTo._id;

          let payload = {
            query: {
              conversationId: this.message._id
            },
            body:{
              text: this.replyModal.text
            }
          }

          if(this.attachmentPreview.length){
            const formDataImage = new FormData();
            formDataImage.append('file', this.attachment);

            this.loader.sendingFile = true; 

          _twilio.api.message.reply(payload, formDataImage, (err, newMessage) => {
            if(err) return alert(err.data.message);
              newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

                  this.attachmentPreview = ''
                  this.attachment = ''
      

              this.loader.sendingFile = false;  
              this.loader.sending = false;  

              if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
              } 
            });
          }


          if(!this.replyModal.text || !this.replyModal.text.length) return;

          const formData = new FormData();
          formData.append('text', this.replyModal.text);

          _twilio.api.message.reply(payload, formData, (err, newMessage) => {
            if(err) return alert(err.data.message);
              this.replyModal.text = "";
              newMessage.from.avatar = '';
              
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

              this.loader.sending = false;  

              if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }
              

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);

                this.closeModal();
              } 
            });
          })   
    },
    async facebookDirectMessageReply(_id, status) {
      if((!this.replyModal.text || !this.replyModal.text.length) && !this.attachmentPreviews.length) return alert('Input cannot be empty!');

      this.loader.sending = true;

      console.log('async worked')

      let objDiv = document.getElementById("overflow");

      if(objDiv){
        var current = objDiv.scrollHeight;
      }

      let tagResponse = await this.addIntoTagsSync(status, this.getEnumaratedTags.Archived, this.message);

        this.replyModal.repliedMessage._id = this.replyTo._id;

          let payload = {
            query: {
              conversationId: this.message._id
            },
            body:{
              text: this.replyModal.text
            }
          }

          if(this.attachmentPreviews.length){

          this.loader.sendingFile = true; 

          for (const singleAttachment of this.attachments) {
            //console.log(singleAttachment)
            const formDataImage = new FormData();
            formDataImage.append('file', singleAttachment);

            let {err, data} = await _facebook.api.directMessage.replyAsync(payload, formDataImage);
            if(err) return alert(err.message);

            var newMessage = data;

            newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar

            this.message.replies.push(newMessage);

            if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }
          }
              

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

                  this.attachmentPreviews = []
                  this.attachments = []
      

              this.loader.sendingFile = false;  
              this.loader.sending = false;  


              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);

              } 
            
          }

          if(!this.replyModal.text || !this.replyModal.text.length) return;

          const formData = new FormData();
          formData.append('text', this.replyModal.text);

          _facebook.api.directMessage.reply(payload, formData, (err, newMessage) => {
            if(err) return alert(err.message);
              this.replyModal.text = "";
              newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar

              //Add links into messages
              if(newMessage.text && newMessage.text.length){
                const urlRegex = /(https?:\/\/[^\s]+)/g;
                newMessage.urls = newMessage['text'].match(urlRegex);
              }

              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

              this.loader.sending = false;  

              if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }
              

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
            });
          
    },
/*     facebookDirectMessageReply(_id, status){
      if((!this.replyModal.text || !this.replyModal.text.length) && !this.attachmentPreview.length) return alert('Input cannot be empty!');
      this.loader.sending = true;

      let objDiv = document.getElementById("overflow");

      if(objDiv){
        var current = objDiv.scrollHeight;
      }

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        this.replyModal.repliedMessage._id = this.replyTo._id;

          let payload = {
            query: {
              conversationId: this.message._id
            },
            body:{
              text: this.replyModal.text
            }
          }

          if(this.attachmentPreview.length){
            const formDataImage = new FormData();
            formDataImage.append('file', this.attachment);

            this.loader.sendingFile = true; 

          _facebook.api.directMessage.reply(payload, formDataImage, (err, newMessage) => {
            if(err) return alert(err.data.message);
              newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

                  this.attachmentPreview = ''
                  this.attachment = ''
      

              this.loader.sendingFile = false;  
              this.loader.sending = false;  

              if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
              } 
            });
          }


          if(!this.replyModal.text || !this.replyModal.text.length) return;

          const formData = new FormData();
          formData.append('text', this.replyModal.text);

          _facebook.api.directMessage.reply(payload, formData, (err, newMessage) => {
            if(err) return alert(err.data.message);
              this.replyModal.text = "";
              newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

              this.loader.sending = false;  

              if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }
              

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
            });
          })   
    }, */
    facebookCommentReply(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {
        this.replyModal.repliedMessage._id = this.replyTo._id;
        let payload = {
            query: {
              conversationId: this.replyModal.repliedMessage._id
            },
            body:{
              text: this.replyModal.text
            }
          }
          _facebook.api.comment.reply(payload, (err, newMessage) => {
              if(err) {
              alert(err.data.message);
              return this.closeModal();
            } 
              this.replyModal.text = "";
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage
              this.loader.sending = false;

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              }              
          })   
        })   
    },
    facebookCommentReplyPrivately(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {
        this.replyModal.repliedMessage._id = this.replyTo._id;
        let payload = {
            query: {
              conversationId: this.replyModal.repliedMessage._id
            },
            body:{
              text: this.replyModal.text
            }
          }
          _facebook.api.comment.replyPrivately(payload, (err, newMessage) => {
              if(err) {
              alert(err.data.message);
              return this.closeModal();
            } 
              this.replyModal.text = "";
              //this.message.replies.push(newMessage);

/*               let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage */

              this.loader.sending = false;

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              }else{
                this.closeModal();
              }     
          })   
        })   
    },
        likeLinkedInComment(message, platform, type, event){
          let payload = {
            query : {
              commentId: message._id
            }
          }
          _linkedIn.api.comment.like(payload, (err, likedLinkedInComment) => {
            if(err) return alert(err.message)
            //this.message.page = likedTweet.page._id

            if(type == 'reply'){
              this.message.replies[_.findIndex(this.message.replies, (o) => { return o._id == message._id })].liked = likedLinkedInComment.liked
            }else{
              this.message.liked = likedLinkedInComment.liked
            }
          });
        },
        likeFacebookComment(message, platform, type, event){
          this.isLikingFacebook = true;
          
          let payload = {
            query : {
              fbCommentId: message._id
            }
          }
          _facebook.api.comment.like(payload, (err, likedFbComment) => {
            if(err) return alert(err.message)
            //this.message.page = likedTweet.page._id

            if(type == 'reply'){
              this.message.replies[_.findIndex(this.message.replies, (o) => { return o._id == message._id })].liked = likedFbComment.liked
            }else{
              this.message.liked = likedFbComment.liked
            }
            this.isLikingFacebook = false;
          });
        },
        undoLikeFacebookComment(message, platform, type, event){
          this.isUnlikingFacebook = true;
           /* if(event.srcElement.lastChild.textContent == 'Unliking...') return alert('Be patient! please :)') 
             event.srcElement.textContent = 'Unliking...';  */
          let payload = {
            query : {
              fbCommentId: message._id
            }
          }
          _facebook.api.comment.undoLike(payload, (err, undoLikedFbComment) => {
            if(err) return alert(err.message)
            //this.message.page = likedTweet.page._id

            if(type == 'reply'){
               /* event.srcElement.textContent = " Like\n                    " */
              this.message.replies[_.findIndex(this.message.replies, (o) => { return o._id == message._id })].liked = undoLikedFbComment.liked
            }else{
              /*  event.srcElement.textContent = " Like\n                    " */
              this.message.liked = undoLikedFbComment.liked
            }
            this.isUnlikingFacebook = false;
          });
        },
    twitterDirectMessage(_id, status){
  if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      //bunu her yerde kullanicaz ondan dolayi thislerin (data) içine taşı lütfen
      let objDiv = document.getElementById("overflow");

      if(objDiv){
        var current = objDiv.scrollHeight;
      }

    this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        let payload = {
          query: {
            _id: this.replyTo._id
          },
          body: {
            text: this.replyModal.text
          }
        }

          _twitter.api.directMessage.reply(payload, (err, newMessage) => {
            if(err) return alert(err.data.message);
              this.replyModal.text = "";
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage

              this.loader.sending = false;       

              if(objDiv){
                this.scrollToSmoothly(objDiv.scrollHeight, objDiv, current);
              }
              

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              }             
            })
          })
      },
      twitterDM2(_id, status){
      if((!this.replyModal.text || !this.replyModal.text.length) && !this.attachmentPreview.length) return alert('Input cannot be empty!');
      this.loader.sending = true;

      let objDiv = document.getElementById("overflow");

      if(objDiv){
        var current = objDiv.scrollHeight;
      }

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        if(this.show.twitterDm) {
          this.replyModal.text = this.replyModal.text + ' https://twitter.com/messages/compose?recipient_id=' + this.accountsById[this.replyTo.data.page].id
        }

        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            _id: this.replyTo._id
          },
          body: {
            text: this.replyModal.text
          }
        }

          if(this.attachmentPreview.length){
            const formDataImage = new FormData();
            formDataImage.append('file', this.attachment);

            this.loader.sendingFile = true; 

          _twitter.api.directMessage.reply(payload, formDataImage, (err, newMessage) => {
            if(err) return alert(err.data.message);
              newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar



            if(newMessage.attachments && newMessage.attachments.length){
              newMessage.attachments[0].src = config.url + "/twitter/attachments?conversationId=" + this.message._id + "&src=" + newMessage.attachments[0].src + "&accessToken=" + this.getJwt
            }
        

              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

                  this.attachmentPreview = ''
                  this.attachment = ''
      

              this.loader.sendingFile = false;  
              this.loader.sending = false;  

              if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
              } 
            });
          }


          if(!this.replyModal.text || !this.replyModal.text.length) return;

          const formData = new FormData();
          formData.append('text', this.replyModal.text);

          _twitter.api.directMessage.reply(payload, formData, (err, newMessage) => {
            if(err) return alert(err.data.message);
              this.replyModal.text = "";
              newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

              this.loader.sending = false;  

              if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }
              

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
            });
          })   
    },
      twitterTweet2(_id, status){
      if((!this.replyModal.text || !this.replyModal.text.length) && !this.attachmentPreview.length) return alert('Input cannot be empty!');
      this.loader.sending = true;

      let objDiv = document.getElementById("overflow");

      if(objDiv){
        var current = objDiv.scrollHeight;
      }

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        if(this.show.twitterDm) {
          this.replyModal.text = this.replyModal.text + ' https://twitter.com/messages/compose?recipient_id=' + this.accountsById[this.replyTo.data.page].id
        }

        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            _id: this.replyTo._id
          },
          body: {
            text: this.replyModal.text
          }
        }

          if(this.attachmentPreview.length){
            const formDataImage = new FormData();
            formDataImage.append('file', this.attachment);

            this.loader.sendingFile = true; 

          _twitter.api.comment.reply(payload, formDataImage, (err, newMessage) => {
            if(err) return alert(err.data.message);
              newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar

            if(newMessage.attachments && newMessage.attachments.length){
              newMessage.attachments[0].src = config.url + "/twitter/attachments?conversationId=" + this.message._id + "&src=" + newMessage.attachments[0].src + "&accessToken=" + this.getJwt
            }

              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

                  this.attachmentPreview = ''
                  this.attachment = ''
      

              this.loader.sendingFile = false;  
              this.loader.sending = false;  

              if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
              } 
            });
          }


          if(!this.replyModal.text || !this.replyModal.text.length) return;

          const formData = new FormData();
          formData.append('text', this.replyModal.text);

          _twitter.api.comment.reply(payload, formData, (err, newMessage) => {
            if(err) return alert(err.data.message);
              this.replyModal.text = "";
              newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

              this.loader.sending = false;  

              if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }
              

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
            });
          })   
    },
    twitterTweet(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;


      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        if(this.show.twitterDm) {
          this.replyModal.text = this.replyModal.text + ' https://twitter.com/messages/compose?recipient_id=' + this.accountsById[this.replyTo.data.page].id
        }

        let payload = {
          query: {
            _id: this.replyTo._id
          },
          body: {
            text: this.replyModal.text
          }
        }
 
          _twitter.api.comment.reply(payload, (err, newMessage) => {
            if(err) return alert(err.data.message);
              this.replyModal.text = "";
              this.message.replies.push(newMessage);
              
              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage

              this.loader.sending = false;

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              }            
            }) 
            })   
      },
        likeTweet(message, platform, type, event){
          this.isLikingTwitter = true
          let payload = {
            query : {
              tweetId: message._id
            }
          }
          _twitter.api.comment.like(payload, (err, likedTweet) => {
            if(err) return alert(err.message)
            //this.message.page = likedTweet.page._id

            if(type == 'reply'){
              this.message.replies[_.findIndex(this.message.replies, (o) => { return o._id == message._id })].liked = likedTweet.liked
            }else{
              this.message.liked = likedTweet.liked
            }
            this.isLikingTwitter = false
          });
        },
        undoLikeTweet(message, platform, type, event){
          this.isUnlikingTwitter = true
          let payload = {
            query : {
              tweetId: message._id
            }
          }
          _twitter.api.comment.undoLike(payload, (err, unLikedTweet) => {
            if(err) return alert(err.message)
            //this.message.page = unLikedTweet.page._id

            if(type == 'reply'){
              this.message.replies[_.findIndex(this.message.replies, (o) => { return o._id == message._id })].liked = unLikedTweet.liked
            }else{
              this.message.liked = unLikedTweet.liked
            }
            this.isUnlikingTwitter = false
          });
        },
        reTweet(message, platform, type, event){
          let payload = {
            query : {
              tweetId: message._id
            }
          }
          _twitter.api.comment.reTweet(payload, (err, reTweetedTweet) => {
            if(err) return alert(err.message)

            //this.message.page = reTweetedTweet.page._id

            if(type == 'reply'){
              this.message.replies[_.findIndex(this.message.replies, (o) => { return o._id == message._id })].retweeted = reTweetedTweet.retweeted
            }else{
              this.message.retweeted = reTweetedTweet.retweeted
            }
          });
        },
        undoReTweet(message, platform, type, event){
          let payload = {
            query : {
              tweetId: message._id
            }
          }
          _twitter.api.comment.undoReTweet(payload, (err, undoReTweetedTweet) => {
            if(err) return alert(err.message)

            //this.message.page = undoReTweetedTweet.page._id

            if(type == 'reply'){
              this.message.replies[_.findIndex(this.message.replies, (o) => { return o._id == message._id })].retweeted = undoReTweetedTweet.retweeted
            }else{
              this.message.retweeted = undoReTweetedTweet.retweeted
            }
          });
        },
    youtubeReply(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {
        this.replyModal.repliedMessage._id = this.replyTo._id;


        let payload = {
          query: {
            conversationId: this.replyModal.repliedMessage._id
          },
          body : {
            text: this.replyModal.text
          }
        }


          _youtube.api.comment.reply(payload, (err, newMessage) => {
                        if(err) {
              alert(err.data.message);
              return this.closeModal();
            } 
              this.replyModal.text = "";
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage

              this.loader.sending = false;


              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              }           
            })   
            })   
      },
      gmailReply(_id, status){

      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            _id: this.replyModal.repliedMessage._id
          },
          body : {
            text: this.replyModal.text
          }
        }

      _gmail.api.email.reply(payload, (err, newMessage) => {
           if(err) {
              alert(err.data.message);
              return this.closeModal();
            } 

              this.replyModal.text = "";

            let foundedPage = _.find( this.accounts, { _id: this.message.page });

            newMessage.from = {}
            newMessage.from.id = foundedPage._id;
            newMessage.from.name = foundedPage.name;
            newMessage.from.avatar = foundedPage.avatar;

              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage

              this.loader.sending = false;
              
              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
      })

      });

    },
      emailReply(_id, status){

      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            _id: this.replyModal.repliedMessage._id
          },
          body : {
            text: this.replyModal.text
          }
        }

      _email.api.email.reply(payload, (err, newMessage) => {
           if(err) {
              alert(err.data.message);
              return this.closeModal();
            } 

              this.replyModal.text = "";

            let foundedPage = _.find( this.accounts, { _id: this.message.page });

            newMessage.from = {}
            newMessage.from.id = foundedPage._id;
            newMessage.from.name = foundedPage.name;
            newMessage.from.avatar = foundedPage.avatar;

              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage
              //if(index != -1) this.$set(this.messages, index, message);

              

              this.loader.sending = false;
              
              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
      })

      });

    },
      linkedInReply(_id, status){

      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            commentId: this.replyModal.repliedMessage._id
          },
          body : {
            text: this.replyModal.text
          }
        }

      _linkedIn.api.comment.reply(payload, (err, newMessage) => {
           if(err) {
              alert(err.data.message);
              return this.closeModal();
            } 

              this.replyModal.text = "";

            let foundedPage = _.find( this.accounts, { _id: this.message.page });

            newMessage.from = {}
            newMessage.from.id = foundedPage._id;
            newMessage.from.name = foundedPage.name;
            newMessage.from.avatar = foundedPage.avatar;

              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage

              this.loader.sending = false;
              
              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
      })

      });

    },
    googleMyBusinessReviewReply(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            _id: this.message._id
          },
          body : {
            text: this.replyModal.text
          }
        }

            _googlemybusiness.api.review.reply(payload, (err, newMessage) => {
              if(err) {
              alert(err.data.message);
              return this.closeModal();
            } 
              this.replyModal.text = "";
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage

              this.loader.sending = false;
              this.addUsernameTags()
              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
    
            }) 
            }) 
      },
    twilioReply(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            _id: this.message._id
          },
          body : {
            text: this.replyModal.text
          }
        }

            twilio.api.message.reply(payload, (err, newMessage) => {
              if(err) {
              alert(err.data.message);
              return this.closeModal();
            } 
              this.replyModal.text = "";
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage

              this.loader.sending = false;
              
              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
    
            }) 
            }) 
      },
    playStoreReviewReply(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            _id: this.replyModal.repliedMessage._id
          },
          body : {
            text: this.replyModal.text
          }
        }

            _playstore.api.review.reply(payload, (err, newMessage) => {
                        if(err) {
              alert(err.data.message);
              return this.closeModal();
            } 
              this.replyModal.text = "";
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage

              this.loader.sending = false;
              this.addUsernameTags()
              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
    
            }) 
            }) 
      },
    appStoreReviewReply(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {

        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            _id: this.replyModal.repliedMessage._id
          },
          body : {
            text: this.replyModal.text
          }
        }

          _appstore.api.review.reply(payload, (err, newMessage) => {
                        if(err) {
              alert(err.data.message);
              return this.closeModal();
            } 
              this.replyModal.text = "";
              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage

              this.loader.sending = false;
              this.addUsernameTags()
              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
    
            })  
            }) 
      },
    instagramAdReply(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {
        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            conversationId: this.replyModal.repliedMessage._id
          },
          body : {
            text: this.replyModal.text
          }
        }

          _instagram.api.adcomment.reply(payload, (err, data) => {
            if(err) {
              if(err.data.uniqueCode && err.data.uniqueCode == 1453){
                alert('The message was deleted by a person who sent this comment!');
                //console.log('$$', this.replyTo.type)
                if(this.replyTo.type == 'message'){
                  this.message.tags.push(this.getEnumaratedTags.Deleted._id)
                  return;
                }else{
                   this.message.replies[_.findIndex(this.message.replies, { _id: _id })].tags.push(this.getEnumaratedTags.Deleted._id)
                  return;
                }
              }else{
                return alert(err.data.message);
              }
            } 

            let foundedPage = _.find( this.accounts, { _id: this.message.page });

            data.from = {}
            data.from.id = foundedPage._id;
            data.from.name = foundedPage.name;
            data.from.avatar = foundedPage.avatar;

            this.loader.sending = false;
            this.replyModal.text = "";
            this.message.replies.push(data);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = data

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              }             
          });
          });
      },
    instagramCommentReply(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {
        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            conversationId: this.replyModal.repliedMessage._id
          },
          body : {
            text: this.replyModal.text
          }
        }

        console.log('##2', payload)

          _instagram.api.comment.reply(payload, (err, data) => {
            if(err) {
              if(err.data.uniqueCode && err.data.uniqueCode == 1453){
                alert('The message was deleted by a person who sent this comment!');
                console.log('$$', this.replyTo.type)
                if(this.replyTo.type == 'message'){
                  this.message.tags.push(this.getEnumaratedTags.Deleted._id)
                  return;
                }else{
                   this.message.replies[_.findIndex(this.message.replies, { _id: _id })].tags.push(this.getEnumaratedTags.Deleted._id)
                  return;
                }
              }else{
                return alert(err.data.message);
              }
            } 

            let foundedPage = _.find( this.accounts, { _id: this.message.page });

            data.from = {}
            data.from.id = foundedPage._id;
            data.from.name = foundedPage.name;
            data.from.avatar = foundedPage.avatar;

            this.loader.sending = false;
            this.replyModal.text = "";
            this.message.replies.push(data);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = data

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              }             
          }); 
          });
      },


      async instagramDirectMessageReply(_id, status) {
      //if((!this.replyModal.text || !this.replyModal.text.length) && !this.attachmentPreviews.length) return alert('Input cannot be empty!');

      this.loader.sending = true;

      console.log('async worked')

      let objDiv = document.getElementById("overflow");

      if(objDiv){
        var current = objDiv.scrollHeight;
      }

      let tagResponse = await this.addIntoTagsSync(status, this.getEnumaratedTags.Archived, this.message);

        this.replyModal.repliedMessage._id = this.replyTo._id;

          let payload = {
            query: {
              conversationId: this.message._id
            },
            body:{
              text: this.replyModal.text
            }
          }


          if (document.getElementById('voiceRecordElement').src && document.getElementById('voiceRecordElement').src.length) {
            console.log('record exist!')


            //window.juphyVoiceRecord.audioFile

            const formDataAudio = new FormData();
            formDataAudio.append('audioFile', window.juphyVoiceRecord.audioFile);

/*             lastModified: 1691520305437
            name: "Screen Shot 2023-08-08 at 11.45.03 AM.png"
            size: 9594
            type: "image/png"
            webkitRelativePath: "" */

            let {err, data} = await _instagram.api.directMessage.replyAsync(payload, formDataAudio);
            if(err) return alert(err.message);

            var newMessage = data;

            newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar

            this.message.replies.push(newMessage);

            if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }

          } 

          if(this.attachmentPreviews.length){
        //  console.log('budur' + this.attachmentPreviews)
          this.loader.sendingFile = true; 

          for (const singleAttachment of this.attachments) {
            //console.log(singleAttachment)
            const formDataImage = new FormData();
            formDataImage.append('file', singleAttachment);
       //     console.log('budur2' + formDataImage);

            let {err, data} = await _instagram.api.directMessage.replyAsync(payload, formDataImage);
            if(err) return alert(err.message);

            var newMessage = data;

            newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar

            this.message.replies.push(newMessage);

            if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }
          }
              

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

                  this.attachmentPreviews = []
                  this.attachments = []
      
              this.loader.sendingFile = false;  
              this.loader.sending = false;  

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);

              } 
            
          }

          if(!this.replyModal.text || !this.replyModal.text.length) return;

          const formData = new FormData();
          formData.append('text', this.replyModal.text);

          _instagram.api.directMessage.reply(payload, formData, (err, newMessage) => {
            if(err) return alert(err.message);
              this.replyModal.text = "";
              newMessage.from.avatar = this.accountsByPId[newMessage.from.id].avatar



              let foundedPage = _.find( this.accounts, { _id: this.message.page });

              newMessage.from = {}
              newMessage.from.id = foundedPage._id;
              newMessage.from.name = foundedPage.name;
              newMessage.from.avatar = foundedPage.avatar;

              //Add links into messages
              if(newMessage.text && newMessage.text.length){
                const urlRegex = /(https?:\/\/[^\s]+)/g;
                newMessage.urls = newMessage['text'].match(urlRegex);
              }

              this.message.replies.push(newMessage);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = newMessage;

              this.loader.sending = false;  

              if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }
              
              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              } 
            });
          
    },

/*     instagramDirectMessageReply(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      let objDiv = document.getElementById("overflow");

      if(objDiv){
        var current = objDiv.scrollHeight;
      }

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {
        this.replyModal.repliedMessage._id = this.replyTo._id;

        let payload = {
          query: {
            conversationId: this.replyModal.repliedMessage._id
          },
          body : {
            text: this.replyModal.text
          }
        }

          _instagram.api.directMessage.reply(payload, (err, data) => {
            if(err) {
              if(err.data.uniqueCode && err.data.uniqueCode == 1453){
                alert('The message was deleted by a person who sent this comment!');
                console.log('$$', this.replyTo.type)
                if(this.replyTo.type == 'message'){
                  this.message.tags.push(this.getEnumaratedTags.Deleted._id)
                  return;
                }else{
                   this.message.replies[_.findIndex(this.message.replies, { _id: _id })].tags.push(this.getEnumaratedTags.Deleted._id)
                  return;
                }
              }else{
                return alert(err.data.message);
              }
            } 

            let foundedPage = _.find( this.accounts, { _id: this.message.page });

            data.from = {}
            data.from.id = foundedPage._id;
            data.from.name = foundedPage.name;
            data.from.avatar = foundedPage.avatar;

            //Add links into messages
            if(data.text && data.text.length){
                const urlRegex = /(https?:\/\/[^\s]+)/g;
                data.urls = data.text.match(urlRegex);
              }

            this.loader.sending = false;
            this.replyModal.text = "";
            this.message.replies.push(data);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = data

                if(objDiv){
                 setTimeout(() => {
                    this.sss(objDiv.scrollHeight, objDiv, current);
                  }, 50);
              }

              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              }             
          });
          });
      }, */
    instagramMentionReply(_id, status){
      if(!this.replyModal.text || !this.replyModal.text.length) return alert('Input cannot be empty!')
      this.loader.sending = true;

      this.addIntoTagsCb(status, this.getEnumaratedTags.Archived, this.message, (res) => {
        let payload = {
          query: {
            repliedMessageId: this.replyTo._id
          },
          body: {
            text: this.replyModal.text
          }
        }
          _instagram.api.mention.reply(payload, (err, data) => {
            if(err) {
              if(err.data.uniqueCode && err.data.uniqueCode == 1453){
                alert('The message was deleted by a person who sent this comment!');
                console.log('$$', this.replyTo.type)
                if(this.replyTo.type == 'message'){
                  this.message.tags.push(this.getEnumaratedTags.Deleted._id)
                  return;
                }else{
                   this.message.replies[_.findIndex(this.message.replies, { _id: _id })].tags.push(this.getEnumaratedTags.Deleted._id)
                  return;
                }
              }else{
                return alert(err.data.message);
              }
            } 

            let foundedPage = _.find( this.accounts, { _id: this.message.page });

            data.from = {}
            data.from.id = foundedPage._id;
            data.from.name = foundedPage.name;
            data.from.avatar = foundedPage.avatar;

/* 
            if(!data.to) return alert('Please, share this error message with developers to solve problem quickly' + JSON.stringify(data))
            if(!data.to.id) data.to.id = data.to.nick;
            if(!data.to.name) data.to.name = data.to.nick;
            if(!data.to.avatar) data.to.avatar = '/img/default_avatar.jpg';   */          

            this.replyModal.text = "";
            this.message.replies.push(data);

              let index = _.findIndex(this.messages, {_id: _id});
              if(index != -1) this.messages[index].reply = data

            this.loader.sending = false;
              if(status) {
                this.addIntoTags('', this.getEnumaratedTags.Ticket, this.message);
                this.addIntoTags('', this.getEnumaratedTags.TicketSolved, this.message);
                this.closeModal();
              }         
          });
          });
      },
      showEmojis(){
      if(localStorage.getItem('recentEmojies')){
        this.recentEmojis = JSON.parse(localStorage.getItem('recentEmojies'))
        this.recentEmojis = _.orderBy(this.recentEmojis, ['updatedAt'], ['desc'])
      }

        if(this.show.emojis) {
          this.show.emojis = false
        } else {
          this.show.emojis = true
        } 
      },
      addEmoji(emoji){

        let textarea = this.$refs.mainTextarea;

          // get cursor's position:
        var startPos = textarea.selectionStart,
          endPos = textarea.selectionEnd,
          cursorPos = startPos,
          tmpStr = textarea.value;


        let cleanEmoji =  Object.assign({}, emoji);

        cleanEmoji.updatedAt = + new Date();
        
        let recentEmojies = [];
        if(localStorage.getItem('recentEmojies')){
          recentEmojies = JSON.parse(localStorage.getItem('recentEmojies'))
        }

        if(!_.find(recentEmojies, { no: cleanEmoji.no })){
          recentEmojies.unshift(cleanEmoji);
        }else{
          recentEmojies[_.findIndex(recentEmojies, (emojiz) => emojiz.no === emoji.no )].updatedAt = + new Date();
        }

        recentEmojies = _.orderBy(recentEmojies, ['updatedAt'], ['desc'])
        
        localStorage.setItem('recentEmojies', JSON.stringify(recentEmojies));
        this.recentEmojis = recentEmojies;

        // insert:
        this.replyModal.text = tmpStr.substring(0, startPos) + emoji.char + tmpStr.substring(endPos, tmpStr.length);

        //this.replyModal.text += emoji.char;
      },
      changeStatus(name){
         api.put("/api/v1/messages/" + this.message._id +"/status", { status: { _id: (name == 'Pending') ? this.statusesByName['Pending']._id : this.statusesByName['Solved']._id } }, (err, data) => {
        if(err) return alert(err.message);
        
        //update new status on modal
        this.message.status =  this.statusesByName[name]._id;

          //update new status on inbox list
          let index = _.findIndex(this.messages, { _id: data._id });
          
          if(index != -1){ //Check if it exist
            this.messages[index].status =  this.statusesByName[name]._id;
            this.setMessages(this.messages);
          }
        })          
      },
    checkStatus(_id){
      return  _.find(this.statuses, (e) => { return e._id == _id }).name
    },
    closeModal(){
                          //supabase
                          window.room.send({
                      type: 'broadcast',
                      event: 'closed',
                      payload: { 
                        messageId: this.message._id,
                        userId: this.getUser._id
                        },
                    })
      this.setConversationModal(false); 
      document.body.classList.remove('overflowYHidden');
      window.history.pushState('', '', '/inbox'); 
    },
    async addIntoTagsSync(status,tag, message){
      if(!status){ return false; }

      let payload = {
        query: {
          messageId: message._id
        },
        body: {
          tagId: tag._id
        }
      }
      let updatedMessage = _system.services.tags.addTagIntoMessageAsync(payload);

              this.tagSelector = true;
              this.message.tags = _.filter(updatedMessage.tags, tag => this.tagsById[tag]);

              
              let index = _.findIndex(this.messages, {_id: this.message._id})

              if(index != -1){
                //console.log(this.messages[index])
                this.messages[index].tags = this.message.tags;
                this.$set(this.messages, index, this.messages[index]);
              }

              return true

    },
    addIntoTagsCb(status,tag, message, callback){
      if(!status){
        return callback(false);
      }

      let payload = {
        query: {
          messageId: message._id
        },
        body: {
          tagId: tag._id
        }
      }

      _system.services.tags.addTagIntoMessage(payload, (err, updatedMessage) => {
        if(err) return console.log(err);

              

              this.tagSelector = false;
              this.message.tags = _.filter(updatedMessage.tags, tag => this.tagsById[tag]);

              
              let index = _.findIndex(this.messages, {_id: this.message._id})

              if(index != -1){
                //console.log(this.messages[index])
                this.messages[index].tags = this.message.tags;
                this.$set(this.messages, index, this.messages[index]);
              }

              callback(true);

              //this.tags = this.tags.filter(tag => !this.message.tags.includes(tag._id))
      });

    },
    addIntoTagsReply(e,tag, message){

      let payload = {
        query: {
          messageId: message._id
        },
        body: {
          tagId: tag._id
        }
      }

      _system.services.tags.addTagIntoMessage(payload, (err, updatedMessage) => {
        if(err) return console.log(err);

              //this.tagSelector = true; // do not close tag selection box

              let i = _.findIndex(this.message.replies, { _id: updatedMessage._id });

              this.message.replies[i].tags = _.filter(updatedMessage.tags, tag => this.tagsById[tag]);

              this.$set(this.message.replies, i, this.message.replies[i]);
              
/* 
              console.log(tag)
              this.currentWorkspace.userTags.push(tag); */

              //let index = _.findIndex(this.messages, {_id: this.message._id})

/*               if(index != -1){
                this.messages[index].tags = this.message.tags;
                this.$set(this.messages, index, this.messages[index]);
              } */


              //this.tags = this.tags.filter(tag => !this.message.tags.includes(tag._id))
      });

    },
    addIntoTags(e,tag, message){

      let payload = {
        query: {
          messageId: message._id
        },
        body: {
          tagId: tag._id
        }
      }

      _system.services.tags.addTagIntoMessage(payload, (err, updatedMessage) => {
        if(err) return console.log(err);

              this.tagSelector = true; // do not close tag selection box
              this.message.tags = _.filter(updatedMessage.tags, tag => this.tagsById[tag]);
/* 
              console.log(tag)
              this.currentWorkspace.userTags.push(tag); */

              let index = _.findIndex(this.messages, {_id: this.message._id})

              if(index != -1){
                this.messages[index].tags = this.message.tags;
                this.$set(this.messages, index, this.messages[index]);
              }


              //this.tags = this.tags.filter(tag => !this.message.tags.includes(tag._id))
      });

    },
    removeFromTags(e, tag, message){

      let payload = {
        query: {
          messageId: message._id,
          tagId: tag
        }
      }
      _system.services.tags.removeTagFromMessage( payload,(err, deletedTagMessage) => {
        if(err) return alert('Please, Try again later!')

        this.tagSelector = true;
        this.message.tags = _.filter(deletedTagMessage.tags, tag => this.tagsById[tag]);

        let index = _.findIndex(this.messages, {_id: this.message._id})

        this.messages[index].tags = this.message.tags;

        this.$set(this.messages, index, this.messages[index]);

        //this.tags = _.reject(this.tags, (o) => { return o._id === tag._id})
      });

      //this.tags.push(e);
    },
    removeFromTagsReply(e, tag, message){

      let payload = {
        query: {
          messageId: message._id,
          tagId: tag
        }
      }
      _system.services.tags.removeTagFromMessage( payload,(err, deletedTagMessage) => {
        if(err) return alert('Please, Try again later!')


        let i = _.findIndex(this.message.replies, { _id: deletedTagMessage._id });

        this.message.replies[i].tags = _.filter(deletedTagMessage.tags, tag => this.tagsById[tag]);

        this.$set(this.message.replies, i, this.message.replies[i]);

/*         this.message.tags = _.filter(deletedTagMessage.tags, tag => this.tagsById[tag]);

        let index = _.findIndex(this.messages, {_id: this.message._id})

        this.messages[index].tags = this.message.tags;

        this.$set(this.messages, index, this.messages[index]); */

      });

      //this.tags.push(e);
    },
    previous(){
      api.get("/api/v1/conversations/" + this.conversationId,(err, data) => {
      //twitter DM data manupulation for attchment
      if(this._is(data, 'directMessage') && this.networksById[data.platform].name == 'Twitter'){
        const newReplies = _.map(data.replies, reply => {
          if(reply.attachments && reply.attachments.length){
            //reply.attachments[0].src = config.url + "/twitter/attachments?conversationId=" + data._id + "&src=" + reply.attachments[0].src
            return reply
          }else{
            return reply
          }
        })
              data.replies = newReplies;
      }

      //Update data for instagram
    if(!data.from.name) data.from.name = data.from.nick;
    if(!data.from.avatar) data.from.avatar = '/img/avatar/roboto/128/latin_'+ this.func.turkishToEnglish(data.from.name).charAt(0).toLowerCase() + '.png'
    if(data.lastReply && !data.lastReply.from.name) data.lastReply.from.name = data.lastReply.from.nick;
    if(data.lastReply && !data.lastReply.from.avatar) data.lastReply.from.avatar = '/img/avatar/roboto/128/latin_'+ this.func.turkishToEnglish(data.lastReply.from.name).charAt(0).toLowerCase() + '.png'
    if(data.replies && data.replies.length){
          let messages = data.replies;
      const updatedByInstagram = _.map(messages, message => {
        if (!message.from.name) message.from.name = message.from.nick;
        if (!message.from.avatar) message.from.avatar = '/img/avatar/roboto/128/latin_'+ this.func.turkishToEnglish(message.from.name).charAt(0).toLowerCase() + '.png'
        return message;
    });
    data.replies = updatedByInstagram;
}

      this.message = data;

      //Set default reply message
      this.replyTo._id = (data.lastReply) ? data.lastReply._id : data._id 
      this.replyTo.name = (data.lastReply) ? data.lastReply.from.name : data.from.name 
      this.replyTo.avatar = (data.lastReply) ? data.lastReply.from.avatar : data.from.avatar 
      this.replyTo.data = (data.lastReply) ? data.lastReply : data
      this.replyTo.type = (data.lastReply) ? 'reply' : 'message'
      this.modalInside = true;
      this.modalInIn = "visible";
      this.show.seeAllMessages = false;
    });
  },
  hideComment(_id, platform, type, event, messageParam){
    this.isHiding = true;
    //console.log(event);
    if(platform == 'Facebook'){
      let payload = {
        _id: _id,
        body: {
          hidden: true
        }
      };
      _facebook.api.comment.hide(payload, (error, message) => {
        if(error) return alert(error.data.message);

      _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }
        this.isHiding = false;
      });
    }
    if(platform == 'Instagram' && !this._is(messageParam, 'ads')){
      let payload = {
        _id: _id,
        body: {
          hidden: true
        }
      };
      _instagram.api.comment.hide(payload, (error, message) => {
        if(error) return alert(error.data.message);

        _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }
        this.isHiding = false;
      });
    }
    if(platform == 'Instagram' && this._is(messageParam, 'ads')){
      let payload = {
        _id: _id,
        body: {
          hidden: true
        }
      };
      _instagram.api.adcomment.hide(payload, (error, message) => {
        if(error) return alert(error.data.message);

        _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }
         this.isHiding = false;
      });
    }
    if(platform == 'Youtube'){
      let payload = {
        query: {
          _id: _id
          },
        body: {
          hidden: true
        }
      };
      _youtube.api.comment.hide(payload, (error, message) => {
        if(error) return alert(error.data.message);

          _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }
         this.isHiding = false;
      });
    }
  },
  unHideComment(_id, platform, type, event, messageParam){
     this.isUnhiding = true;

    if(platform == 'Facebook'){
      let payload = {
        _id: _id,
        body: {
          hidden: false
        }
      };
      _facebook.api.comment.unhide(payload, (error, message) => {
        if(error) return alert(error.data.message);

        _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }
        this.isUnhiding = false;
      });
    }
    if(platform == 'Instagram' && !this._is(messageParam, 'ads')){
      let payload = {
        _id: _id,
        body: {
          hidden: false
        }
      };
      _instagram.api.comment.unhide(payload, (error, message) => {
        if(error) return alert(error.data.message);

        _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }
        this.isUnhiding = false;
      });
    }
    if(platform == 'Instagram' && this._is(messageParam, 'ads')){
      let payload = {
        _id: _id,
        body: {
          hidden: false
        }
      };
      _instagram.api.adcomment.unhide(payload, (error, message) => {
        if(error) return alert(error.data.message);

        _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }
        this.isUnhiding = false;
      });
    }
    if(platform == 'Youtube'){
      let payload = {
        query: {
          _id: _id
          },
        body: {
          hidden: false
        }
      };
      _youtube.api.comment.unhide(payload, (error, message) => {
        if(error) return alert(error.data.message);

        _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }
        this.isUnhiding = false;
      });
    }
  },
  deleteComment(message, platform, type, event){


    if(event.srcElement.lastChild.textContent == 'Deleting...') return alert('Be patient! please :)')
    event.srcElement.textContent = 'Deleting...';

    if(platform == 'Facebook'){
      this.loadingComponent.deleteFacebook = true;
      let payload = {
        _id: message._id
      };
      _facebook.api.comment.delete(payload, (error, message) => {
        if(error) return alert(error.data.message);
        this.loadingComponent.deleteFacebook = false;

        _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }

      });
    }
    if(platform == 'LinkedIn'){
      this.loadingComponent.deleteFacebook = true;
      let payload = {
        query:{
          commentId: message._id
        }
      };
      _linkedIn.api.comment.delete(payload, (error, message) => {
        if(error) return alert(error.data.message);
        this.loadingComponent.deleteFacebook = false;

        _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }

      });
    }
    if(platform == 'Trust Pilot'){
      this.loadingComponent.deleteFacebook = true;
      let payload = {
        query:{
          reviewId: message._id
        }
      };

      _trustpilot.api.review.delete(payload, (error, message) => {
        if(error) return alert(error.data.message);
        this.loadingComponent.deleteFacebook = false;

        _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }

      });
    }
    if(platform == 'Instagram'){
      this.loadingComponent.deleteInstagram = true;
      let payload = {
        _id: message._id
      };
      _instagram.api.comment.delete(payload, (error, message) => {
        if(error) return alert(error.data.message);
              this.loadingComponent.deleteInstagram = false;
        _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }

      });
    }
    if(platform == 'Youtube'){
      let payload = {
        _id: message._id
      };
      _youtube.api.comment.delete(payload, (error, data) => {
        if(error) return alert(error.data.message);
        _.chain([this.message]).concat(this.message.replies).find({ id: message.id }).set('tags', message.tags).value();

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ id: message.id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }

      });
    }

    if(platform == 'Google My Business'){
      let payload = {
        query:{
          _id: this.message._id
        }
      };
      _googlemybusiness.api.review.delete(payload, (error, message) => {
        if(error) return alert(error.data.message);

        if(type == 'reply'){
          const index = _.findIndex(this.message.replies,{ _id: message._id })
          this.$set(this.message.replies, index, this.message.replies[index]);
        }

      });
    }
  },
      throwImgError(event, message){
        console.log('Throwed');
        event.srcElement.src = '/img/avatar/roboto/128/latin_'+ this.func.turkishToEnglish(message.from.name).charAt(0).toLowerCase() + '.png';
    },
    createNote(){

      this.loader.note = true;

      if(this.note.text.length < 1) return alert('Cannot be empty!')

      let payload = {
        query: {
          messageId: this.message._id,
          workspaceId: this.currentWorkspace._id
        },
        body: {
          text: this.note.text
        }
      }

      _system.services.notes.post(payload, (err, message) => {
        if (err) return alert(err);

        this.note.text = ''

      setTimeout(() => {
      const notesWrapper = document.getElementById("notesWrapper");
      notesWrapper.scrollTop = notesWrapper.scrollHeight;
      }, 100)

        this.message.notes = message.notes;
        this.loader.note = false;
      });

    },
    deleteNote(noteId){

      let payload = {
        query: {
          noteId: noteId,
          messageId: this.message._id
        }
      }

      _system.services.notes.delete(payload, (err, message) => {
        if (err) return alert(err);

        this.message.notes = message.notes;

      });

    },
    isAssigned(teammate){
      if(_.find(this.message.users, { _id: teammate.user._id })) {
        return true
      }else{
        return false
      }
    },
    assignTeammate(teammate){

      let payload = {
        query: {
          messageId: this.message._id
        },
        body: {
          assignedUserId: teammate.user._id,
          assignedWorkspaceId: this.currentWorkspace._id
        }
      }

      _system.services.assignments.post(payload, (err, res) => {
        if(err) alert(err.message);

        this.message.users = res.users 

          if(!_.find(this.message.users, { _id: this.getUser._id })){
                let payload = {
                  query: {
                    messageId: this.message._id
                  },
                  body: {
                    assignedUserId: this.getUser._id,
                    assignedWorkspaceId: this.currentWorkspace._id
                  }
                }

                _system.services.assignments.post(payload, (err, res) => {
                  if(err) alert(err.message);

                  this.message.users = res.users 

                });
          }

      });

    },
    deleteAssignedTeammate(teammate){

      let payload = {
        query: {
          messageId: this.message._id,
          userId: teammate._id
        }
      }

      _system.services.assignments.delete(payload, (err, res) => {
        if(err) alert(err.message);

        this.message.users = res.users 

      });

    },
    getCurrentWorkspaceuser(){
      return _.find(this.workspaceusers, { user: { _id: this.getUser._id }});
    },
    saveCannedResponse(){
      
      if(this.cannedResponse && this.cannedResponse.length){
        let payload = {
          query: {
            workspaceusersId: this.getCurrentWorkspaceuser()._id
          },
          body: {
            text: this.cannedResponse
          }
        }
   
        _system.services.cannedResponses.post(payload, (err, res) => {
          if(err) return alert(err.message);
           let workspaceuserIndex = _.findIndex(this.workspaceusers, { _id: res._id});  

           this.workspaceusers[workspaceuserIndex].quickReplies = res.quickReplies;

            this.cannedResponse = '';
        });
      }
    },
    removeCannedResponse(cannedResponse){

        let payload = {
          query: {
            workspaceusersId: this.getCurrentWorkspaceuser()._id,
            cannedResponseId: cannedResponse._id
          }
        }
   
        _system.services.cannedResponses.delete(payload, (err, res) => {
          if(err) return alert(err.message);

           let workspaceuserIndex = _.findIndex(this.workspaceusers, { _id: res._id});  
           this.workspaceusers[workspaceuserIndex].quickReplies = res.quickReplies;

            this.cannedResponse = '';
        });
      
    },
    setReplyModal(text){
      this.replyModal.text = (this.replyModal.text.length) ? this.replyModal.text + ' ' + text : text;
      this.show.quickReply = false;
      document.getElementById("replyBox").focus();
      this.cannedResponse = '';
    },
    scrollToSmoothly(pos, objDiv, current ,time) {

  if (isNaN(pos)) {
    throw "Position must be a number";
  }
  if (pos < 0) {
    throw "Position can not be negative";
  }
  var currentPos = current || window.scrollY || window.screenTop;
  if (currentPos < pos) {
    var t = 10;
    for (let i = currentPos; i <= pos; i += 10) {
      t += 10;
      setTimeout(() => {
        objDiv.scrollTo(0, i);
      }, t / 2);
    }
  } else {
    time = time || 2;
    var i = currentPos;
    var x;
    x = setInterval(() => {
      objDiv.scrollTo(0, i);
      i -= 10;
      if (i <= pos) {
        clearInterval(x);
      }
    }, time);
  }
},

sss(targetPosition, element, currentPosition ,time) {

targetPosition = targetPosition - 400;
currentPosition = currentPosition - 400;

element.scrollTo(0, targetPosition);

/* var cuteInterval;
 cuteInterval = setInterval(() => {
   current = current + 1;
   
   objDiv.scrollTo(0, current);
console.log('buyuyen', current);
  console.log('AnaHedef', pos);
    if (current == pos) {
      clearInterval(cuteInterval);
    }
 }, 1); */
  
},
    openCannedResponse(){
      (this.show.quickReply) ? this.show.quickReply = false : this.show.quickReply = true

      if(this.show.quickReply){
        var objDiv = document.getElementById("scrollingContainer");
        setTimeout(() => {
          this.scrollToSmoothly(objDiv.scrollHeight, objDiv)
        },1)
      }
    },
    setTagColor(tag){
      if(tag.name == 'Positive') return 'green'
      if(tag.name == 'Negative') return 'red'
      if(tag.name == 'Neutral') return 'gray'
      return ''
    },
    uploadMultiple(){
      document.getElementById('upload').click();
    },
    upload(){
      document.getElementById('upload2').click();
    },
    onFileChange(e){
      var files = e.target.files || e.dataTransfer.files;
      var reader = new FileReader();


      for (let i = 0; i < files.length; i++) {
       if (!files[i].type.match("image")) continue;
        const picReader = new FileReader();
        picReader.addEventListener("load",  (event) => {
          const picFile = event.target;
          this.attachmentPreviews.push(picFile.result);
        });
        picReader.readAsDataURL(files[i]);
       }

      this.attachments = files;

    },
    onFileChange2(e){
      var files = e.target.files || e.dataTransfer.files;
      var image = new Image();
      var reader = new FileReader();

      this.attachment = files[0];

      reader.onload = (e) => {
        console.log(e)
        this.attachmentPreview = e.target.result;
      };

      reader.readAsDataURL(files[0]);

    },
/*     onFileChange(e){
      var files = e.target.files || e.dataTransfer.files;
      console.log(files);
      var image = new Image();
      var reader = new FileReader();

      this.attachment = files[0];

      reader.onload = (e) => {
        console.log(e)
        this.attachmentPreview = e.target.result;
      };

      reader.readAsDataURL(files[0]);
    }, */
    removeAttachment(){
      this.attachmentPreview = '';
      this.attachmentPreviews = [];
      this.attachments = [];
      this.attachment = '';
    },
    openReplyTags(reply){

      let i = _.findIndex(this.message.replies, {_id: reply._id})

      if(this.message.replies[i].tagsOpened) 
        this.message.replies[i].tagsOpened = false 
          else 
            this.message.replies[i].tagsOpened = true

      this.$set(this.message.replies, i, this.message.replies[i]);
    

    },
    filteredMessageTags(tagsById){

      let specialTags = [
        'Direct Message',
        'Hidden',
        'Ads Comments',
        'Deleted',
        'One Star',
        'Two Star',
        'Three Star',
        'Four Star',
        'Five Star',
        'Seen'
      ]

      let tagsIdClone =  Object.assign({}, tagsById);

      tagsIdClone = _.filter(tagsIdClone, (tagId) => this.tagsById[tagId])


      return _.map(tagsIdClone, (tagId) => {

        let object = {
          _id: tagId,
          name: this.tagsById[tagId].name,
          canRemove: (_.some(specialTags, (tag) => tag === this.tagsById[tagId].name )  ) ? false : true,
          color: (this.tagsById[tagId].color && this.tagsById[tagId].color.length) ? this.tagsById[tagId].color : '#d6d6d6'
        }

      if(_.find(this.currentWorkspace.userTags, {_id : tagId})){
        object.color = _.find(this.currentWorkspace.userTags, {_id : tagId}).color
      }
       
        return object
      })
    },
    filteredMessageTagsCreatedByUser(tags){
      let tagsClone =  Object.assign({}, tags);


      let tagz = _.map(tagsClone, (tag) => {
        tag.color = (tag.color && tag.color.length) ? tag.color : '#d6d6d6'
        return tag
      })

      return  tagz.filter(item => {
                  return item.name.toLowerCase().indexOf(this.searchTags.toLowerCase()) > -1
                })
    },
    defaultFilteredTags(){

      let specialTags = [
        'Direct Message',
        'Hidden',
        'Ads Comments',
        'Deleted',
        'One Star',
        'Two Star',
        'Three Star',
        'Four Star',
        'Five Star',
        'Direct Message'
      ]

      //return tags
      let tags =  Object.assign([], this.tagsByTypeName['DefaultMessageTag']) 
      return _.filter(tags, (tag) => !specialTags.includes(tag.name))
    },
    focusNote(){
      document.getElementById('writeNote').focus();
      this.writeNotePointer = true;
      setTimeout(() => {
        this.writeNotePointer = false;
      }, 8000);
    },
    openRetrainModal(reply,message){
      this.retrainModal = true 
    //  console.log('KONTROL ET', reply)
    //  console.log('KONTROL ET2', message)
      this.retrainModalAnswer = reply.text
      this.retrainModalAnswerCount = reply.text.length
      
      const index = _.findIndex(message.replies, item => item.id === reply.id);
      if (index > 0) {
          const previousReply = message.replies[index - 1];
          this.retrainModalQuestion = previousReply.text;
      }else{
        this.retrainModalQuestion = message.text;
      }

      const platformName = this.networksById[message.platform].name;
      this.isShopify = platformName !== 'Shopify';

    },
    closeRetrainModal(){
      this.retrainModal = false
    },
    updateCharacterCount(){
      this.retrainModalAnswerCount = this.retrainModalAnswer.length
    },
    saveRetrainData(){
      this.retrainModal = false 
      let payload = {
        query: {
          pageId: this.message.page
        },
        body:{
          question: this.retrainModalQuestion,
          answer: this.retrainModalAnswer
        }
      }

      _system.services.chatbot.retrainData(payload, (err, res) => {
          if(err) return iziToast.error({ position: 'bottomCenter', title: `${err.data.message}`, });
          iziToast.success({ position: 'bottomCenter', title: 'Updated Your Preference', });

      }); 
    },
  },
  beforeDestroy(){
    //supabase
    //clearInterval(this.polling);
    //window.supabase.removeChannel(this.conversationId)
    console.log('before closed');
  },
  destroyed(){
    //supabase
/*     window.room.send({
      type: 'broadcast',
      event: 'closed',
      payload: { 
        messageId: this.message._id,
        userId: this.getUser._id
        },
    })
 */
  },
  mounted() { 

    //if(this.getUser.email.includes('juphy.com')){
      supabase.from('contacts').select('*').eq('conversation_id', this.conversationId).then(result => {
            if(result.data && result.data[0] && result.data[0].email){
              this.contact.email = result.data[0].email
              this.contact.phone = result.data[0].phone
            }
          })
          .catch(error => {
            // Handle insertion error
            console.log(error)
          });
    //}
    
    AOS.init();

    //supabase
  /*   window.supabase.channel(this.conversationId).on('broadcast', { event: 'typing' }, (data) => { 
      if(this.takeover.state){
        this.replyModal.text = data.payload.text;
      }
  })
          window.conversationRoom = window.supabase.channel(this.conversationId)

      
          window.conversationRoom.subscribe((status) => {
          if (status === 'SUBSCRIBED Conversation') {
              console.log(status);
          }
          })

    let totalWords = this.replyModal.text.split(' ').length
    this.polling = setInterval(() => {

            if(this.replyModal.text.split(' ').length > totalWords){
              totalWords = this.replyModal.text.split(' ').length
              console.log('fired...', totalWords)
                            
              window.conversationRoom.send({
                type: 'broadcast',
                event: 'typing',
                payload: { 
                  date: Date.now(),
                  text: this.replyModal.text
                },
              })
            }
            
        }, 5000) */

          

      //supabase
/*     window.addEventListener('beforeunload', (event) => {
    event.preventDefault();
    event.returnValue = '';
        window.room.send({
        type: 'broadcast',
        event: 'closed',
        payload: { 
          messageId: this.message._id,
          date: Date.now(),
          user: {}
          },
      })
      console.log('closed removed');
      return;
  }); */

    document.body.addEventListener('keyup', e => { if (e.keyCode === 27) { this.closeModal() } }) 
    $('.ui.dropdown').dropdown();



    //if(this.networksById[this.openedMessage.platform].name == "Gmail"){
/*         var quill = new Quill('#gmailReply', {
          placeholder: 'Compose an epic...',
          theme: 'snow'
      }); */
    //}

    },
  created() {
//superbase
this.conversationOpenedDate = Date.now();

    //Check and set tags
    this.dbTags = this.dbTags.filter(e => !this.currentTags.includes(e))

    window.history.pushState('', '', '/inbox?conversation=' + this.conversationId);


    api.get("/api/v1/conversations/" + this.conversationId,(err, data) => {
    
    if(data.feed){
      this.loader.feed = false;
      let payload = {
        query: {
          messageId: data._id
        }
      }
      _system.services.feeds.get(payload, (err, feed) => {
        if(err){
          this.loader.error = err.data.message
          this.loader.feed = true
        }
        
        if(feed){
          this.feed = feed;
          this.feed.load = true;
          this.feed.attachments = _.get(feed, 'attachments', []);
          this.feed.pageName = _.find(this.accounts, { _id: data.page }).name.slice(0,20) + '...';
          this.feed.pageAvatar = _.find(this.accounts, { _id: data.page }).avatar;
          this.loader.feed = true;
        }
      });
    };

    
        if(!data.from){
            message.from = {
              name: 'Unknown'
            }
          }

          if(data.text && data.text.length){
                const urlRegex = /(https?:\/\/[^\s]+)/g;
                data.urls = data.text.match(urlRegex);

                if(data.urls && data.urls.length){
                  data.urls = _.map(data.urls, url => {

                    if(url.charAt(url.length - 1) == '.'){
                      url = url.slice(0, -1);
                    }

                    if(url.charAt(url.length - 1) == ')'){
                      url = url.slice(0, -1);
                    }
                    return url;
                  })
                }
              }

              
              if(data.notes && data.notes.length){
                console.log(data.notes)
                data.notes = _.map(data.notes, note => {
                  const urlRegexNote = /(https?:\/\/[^\s]+)/g;
                  note.urls = note.text.match(urlRegexNote);
                  return note;
                })
            
              }




if(data.replies && data.replies.length){
        data.replies = _.map(data.replies, reply => {

          if(!reply.from){
            reply.from = {
              name: 'Unknown'
            }
          }

          if(reply.text && reply.text.length){
                const urlRegex = /(https?:\/\/[^\s]+)/g;
                reply.urls = reply.text.match(urlRegex);

                if(reply.urls && reply.urls.length){
                  reply.urls = _.map(reply.urls, url => {

                    if(url.charAt(url.length - 1) == '.'){
                      url = url.slice(0, -1);
                    }

                    if(url.charAt(url.length - 1) == ')'){
                      url = url.slice(0, -1);
                    }
                    return url;
                  })
                }

              }

          return reply;
        })
}
          


      //twitter DM data manupulation for attchment
      if(this._is(data, 'directMessage') && this.networksById[data.platform].name == 'Twitter'){
        data.replies = _.map(data.replies, reply => {
          if(reply.attachments && reply.attachments.length){
            //reply.attachments[0].src = config.url + "/twitter/attachments?conversationId=" + data._id + "&src=" + reply.attachments[0].src + "&accessToken=" + this.getJwt
            return reply
          }else{
            return reply
          }
        })
      }

/*       if(data.replies && data.replies.length && data.replies.length > 3) {
        data.replies = data.replies.reverse().splice(0, 3).reverse();
        this.show.seeAllMessages = true;
      } */


          //Update data for Trustpilot
    if(this.networksById[data.platform].name == 'Trust Pilot'){
      if(data.id && data.id.length){
        data.trustPilotLink = "https://businessapp.b2b.trustpilot.com/reviews/" + data.id
      } 
    }

    //Update data for instagram
    if(this.networksById[data.platform].name == 'Instagram'){
      if(!data.from.name) data.from.name = data.from.nick;
      if(!data.from.avatar) data.from.avatar = '/img/avatar/roboto/128/latin_'+ this.func.turkishToEnglish(data.from.name).charAt(0).toLowerCase() + '.png'
      if(data.lastReply && !data.lastReply.from.name) data.lastReply.from.name = data.lastReply.from.nick;
      if(data.lastReply && !data.lastReply.from.avatar) data.lastReply.from.avatar = '/img/avatar/roboto/128/latin_'+ this.func.turkishToEnglish(data.lastReply.from.name).charAt(0).toLowerCase() + '.png'
      if(data.replies && data.replies.length){
            let messages = data.replies;
            const updatedByInstagram = _.map(messages, message => {
              if (!message.from.name) message.from.name = message.from.nick;
              if (!message.from.avatar) message.from.avatar = '/img/avatar/roboto/128/latin_'+ this.func.turkishToEnglish(message.from.name).charAt(0).toLowerCase() + '.png'
              return message;
          });
          data.replies = updatedByInstagram;
      }
    }

      if(!data.tags) data.tags = []

      if(data.tags.length){
        data.tags = _.filter(data.tags, tag => this.tagsById[tag]);
      }


//Update data for Gmail
if(this.networksById[data.platform].name == 'Gmail'){
      if(!data.from.name) data.from.name = data.from.email;
      if(data.lastReply && !data.lastReply.from.name) data.lastReply.from.name = data.lastReply.from.email;

      if(data.replies && data.replies.length){
            let messages = data.replies;
            const updatedByGmail = _.map(messages, message => {
              if (!message.from.name) message.from.name = message.from.email;
              if (!message.from.avatar) message.from.avatar = '/img/avatar/roboto/128/latin_'+ this.func.turkishToEnglish(message.from.name).charAt(0).toLowerCase() + '.png'
              return message;
          });
          data.replies = updatedByGmail;
      }
}

//Update to set who replied?
if(data.replies && data.replies.length){
            const updatedForReplier = _.map(data.replies, message => {
              if (!message.replier) {
                message.repliedBy = { name: '' }
              } else {
                let foundedWsUser = _.find(this.workspaceusers, {user: { _id: message.replier }})
                if(foundedWsUser){
                  message.repliedBy = { name: foundedWsUser.user.name }
                }else{
                   return message;
                }
                
              } 

              return message;
          });
          //console.log(this.workspaceusers)
          data.replies = updatedForReplier;
}


      this.setMessage(data);

      this.message = data;
      //Message loaded so you can show them;


       if(this.message.replies.length){
        setTimeout(() => {
            let topPos = document.getElementById("overflow").offsetTop;
            let sH = document.getElementById("overflow").scrollHeight;
            document.getElementById('overflow').scrollTop = topPos + sH;
           this.currectScrollHeight = sH;
             var objDiv = document.getElementById("scrollingContainer");

          if(sH > 400){
            this.scrolled = true
          }

            setTimeout(() => {
              this.scrollToSmoothly(objDiv.scrollHeight, objDiv)
            },1)

          setTimeout(() => {
            this.show.replies = true;
          },500)
        },1)
     }else{
        this.show.replies = true;
     }
      //Set default reply message
      this.replyTo._id = (data.lastReply) ? data.lastReply._id : data._id 
      this.replyTo.name = (data.lastReply && data.lastReply.from) ? data.lastReply.from.name : data.from.name 
      this.replyTo.avatar = (data.lastReply && data.lastReply.from) ? data.lastReply.from.avatar : data.from.avatar

      let manipulatedText = (data.lastReply && data.lastReply.from) ? data.lastReply.text : data.text

      this.replyTo.text =  (manipulatedText) ? manipulatedText : ''
      this.replyTo.data = (data.lastReply && data.lastReply.from) ? data.lastReply : data
      this.replyTo.type = (data.lastReply && data.lastReply._id) ? 'reply' : 'message'

      this.modalInside = true;
      this.modalInIn = "visible";
    



if(this.message.tags){
  let readIndex = this.message.tags.indexOf(this.getEnumaratedTags.Read._id)
  if(readIndex == -1){
      let tagModel = {
        _id: this.getEnumaratedTags.Read._id
      }
      this.addIntoTags(null, tagModel, this.message)
  }
}

    if(this.message.notes && this.message.notes.length > 3){
      setTimeout(() => {
        const notesWrapper = document.getElementById("notesWrapper");
        notesWrapper.scrollTop = notesWrapper.scrollHeight;
      }, 100)
    }
    });
  }
};
</script>

<template>
<div id="scrollingContainer" class="modalWrapper">
<div @click="closeModal()" class="modal"> </div>
<div style="margin-top: 15px;margin-bottom: 30px;"  class="ui container">
      <div  class="ui grid centered stackable">
        <div class="fifteen wide column" >
          <div style="padding: 0;" @click="closeModal()"  class="ui basic segment right aligned">
            <a style="background: rgba(0,0,0,0.6); position:relative; z-index:999999" class="ui black mini button">Close [ESC]</a>
          </div>
        </div>
      </div>
      <div class="ui grid centered stackable">
      <div style="background: rgba(70, 70, 70, 0.34) none repeat scroll 0% 0%; z-index: 9999;border-radius: 10px;" class="fifteen wide column">
      <div class="ui grid">
        <div style="padding-right:0; z-index: 9999;" class="twelve wide computer sixteen wide mobile column">
        <div style="background: transparent; padding: 0; z-index: 9999999; " class="ui basic segment">
          <div v-if="modalInside" v-on:click.stop style="background: #f5f5f5;  border-color: #f0f0f0;" class="ui basic top attached segment">
            <div class="ui feed">
              <div :style="{ opacity: (_is(message, 'hidden') || _is(message, 'deleted')) ? '.5' : '1' }" class="event">
              <div style="width: 4em;position: relative;" class="label">
                <img style="width: 55px; height:55px;" @error="throwImgError($event, message)" :src="func.replaceImg(message.from.avatar)">
                <div style="top:38px; width: 1.6rem;height: 1.63rem;font-size: 0.8em;border: 1px solid rgb(249, 249, 249);position: absolute; left: -24px; border-radius: 50px;" >
                  <img :src="getPlatformImage(message.platform, message)" alt="">
                </div>

              </div>
                <div :style="(networksById[message.platform].name == 'Email') ? 'overflow: auto;' :''" style="margin-top: 0; margin-bottom: 0;" class="content">
                  
                  <div class="summary">
                    
                    <a v-if="networksById[message.platform].name == 'Instagram'" target="_blank" :href="'https://instagram.com/' + (message.from.nick || message.from.name)">{{message.from.name}}</a>

                    <a v-if="networksById[message.platform].name == 'Trust Pilot'" target="_blank" :href="message.trustPilotLink">
                      {{message.from.name}}
                    </a>

                    <a v-if="networksById[message.platform].name != 'Instagram' && networksById[message.platform].name != 'Trust Pilot'">{{message.from.name}}</a>

                    <div @click="(show.sensitiveData) ? show.sensitiveData = false : show.sensitiveData = true" class="date">
                      <span style=" color: #6d9bc6;" v-if="message.from.email">
                        <span v-if="show.sensitiveData">{{message.from.email}}</span>
                        <span v-if="!show.sensitiveData">*****@*****</span>
                        </span>
                      <span style="color: #6d9bc6;" v-if="message.from.phone">
                        <span v-if="show.sensitiveData">{{message.from.phone}}</span>
                        <span v-if="!show.sensitiveData">*****@******</span>
                        </span>
                      {{func.since(message.createdAt)}} ago
                    </div>
                  </div>
                  <div class="extra text">
                    <span v-if="message.text && networksById[message.platform].name != 'Gmail' && networksById[message.platform].name != 'Email'" class="messageBlock3">
                      {{message.text}}
                      </span>
                      <span style="display: block;" v-if="message.urls">
                        <a style="margin-top: 1rem;" target="_blank" class="ui icon small label" v-for="url in message.urls" :key="url" :href="url"> <i class="external alternate icon"></i>{{ url }} </a>
                      </span>
                    <span v-if="message.text && (networksById[message.platform].name == 'Email' || networksById[message.platform].name == 'Gmail')">
                      <!-- <span v-html="message.text"></span> -->
                      <iframe :src="'/emailrender?messageId=' + message._id" width="100%" height="500px" frameborder="0"></iframe>
                      </span>


                    <div v-if="networksById[message.platform].name == 'Gmail' && message.attachments && message.attachments.length"  class="ui basic segment">
                      <h3>Attachments</h3>
                        <a v-for="file in message.attachments" :key="file.name" style="display:block; margin-bottom:5px;" :href="'https://api.juphy.com/gmail/messages/' + message._id +'/attachment/' + file.id + '.download?accessToken=' + getJwt"  class="ui label">
                            <i class="download icon"></i> {{file.name}}
                        </a>
                    </div>

                  </div>
                   <div v-if="message.attachments" class="extra images">
                      <a v-for="(attachment, index) in message.attachments" :key="`${index}`" target="_blank" :href="attachment.src">
                         <span v-if="attachment.format && attachment.format == 'video'">
                          <video  width="200" controls>
                            <source :src="attachment.src" type="video/mp4">
                            <source :src="attachment.src" type="video/ogg">
                          </video>
                        </span>

                        <span v-if="attachment.format && attachment.format == 'photo'">
                            <img style="background: #fff;padding: 3px;border: 1px solid #eee;border-radius: 2px;" :src="attachment.src">
                        </span>

                        <span v-if="attachment.format && attachment.format == 'image'">
                            <img style="background: #fff;padding: 3px;border: 1px solid #eee;border-radius: 2px;" :src="attachment.src">
                        </span>

                        <span v-if="attachment.format && attachment.format == 'url'">
                          <a target="_blank" :href="attachment.src">{{attachment.src}}</a>
                        </span>

                        <span v-if="!attachment.format">
                            <img style="background: #fff;padding: 3px;border: 1px solid #eee;border-radius: 2px;" :src="attachment.src">
                        </span>
                      </a>
                    </div>
<!--                    <div v-if="message.attachments && getUser.email.includes('jeenasikho.co.in')" class="extra images">
                      <a v-for="(attachment, index) in message.attachments" :key="`${index}`" target="_blank" :href="attachment.src">
                         <video width="400" controls>
                          <source :src="attachment.src" type="video/mp4">
                          <source :src="attachment.src" type="video/ogg">
                        </video>
                         </a>
                    </div> -->
                  <div  v-if="_is(message, 'deleted')" class="meta">
                    <span style="padding-left: 4px;" class="ui red mini label">Deleted</span>
                  </div>
                  <div  v-if="!_is(message, 'deleted') && getRole.name == 'Admin' || getRole.name == 'Moderator'"  class="meta">
                    <a v-if="!_is(message, 'hidden') && !networksById[message.platform].name == 'Shopify'" @click="updateReplyTo(message.from.name, message._id, message.from.avatar, message.text, message, 'message')" class="reply">
                      <i class="reply icon"></i> Reply
                    </a>
                    <a v-if="!_is(message, 'hidden') && !_is(message, 'directMessage') && networksById[message.platform].name == 'Facebook'" @click="updateReplyTo(message.from.name, message._id, message.from.avatar, message.text, message, 'commentPrivately')" class="reply">
                      <i class="facebook messenger icon"></i> Reply Privately
                    </a>
                    <a v-if="(networksById[message.platform].name == 'LinkedIn' && !checkLinkedInCommentIsLiked(message) && !_is(message, 'directMessage'))" @click="likeLinkedInComment(message, networksById[message.platform].name, 'message', $event)" class="like">
                      <i class="like icon"></i> Like
                    </a>
                    <a v-if="(networksById[message.platform].name == 'LinkedIn' && checkLinkedInCommentIsLiked(message) && !_is(message, 'directMessage'))"  class="like active">
                      <i class="like icon"></i> Liked
                    </a>
                    <a v-if="(networksById[message.platform].name == 'Facebook' && !checkFacebookCommentIsLiked(message) && !_is(message, 'directMessage')&& !isLikingFacebook)" @click="likeFacebookComment(message, networksById[message.platform].name, 'message', $event)" class="like">
                      <i class="like icon"></i> Like
                    </a>
                    <span v-else-if="isLikingFacebook">Liking...</span>
                    <a v-if="(networksById[message.platform].name == 'Facebook' && checkFacebookCommentIsLiked(message) && !_is(message, 'directMessage')&& !isUnlikingFacebook)" @click="undoLikeFacebookComment(message, networksById[message.platform].name, 'message', $event)" class="like active">
                      <i class="like icon"></i> Liked
                    </a>
                    <span v-else-if="isUnlikingFacebook">Unliking...</span>
                    <a v-if="(networksById[message.platform].name == 'Facebook' && !_is(message, 'directMessage') && !_is(message, 'hidden')) && !isHiding || networksById[message.platform].name == 'Instagram' && !_is(message, 'directMessage') && !_is(message, 'hidden') && !_is(message, 'mention') && !isHiding || (networksById[message.platform].name == 'Youtube' && !_is(message, 'hidden')) && !isHiding" @click="hideComment(message._id, networksById[message.platform].name, 'message', $event, message)" class="reply">
                      <i class="hide icon"></i>Hide
                    </a>
                    <span v-else-if="isHiding">Hiding...</span>
                    <a v-if="networksById[message.platform].name != 'Twitter' && !accountsByPId[message.from.id] && _is(message, 'hidden') && !isUnhiding || (networksById[message.platform].name == 'Youtube' &&  _is(message, 'hidden')) && !isUnhiding" @click="unHideComment(message._id, networksById[message.platform].name, 'message', $event, message)" class="reply">
                      <i class="unhide icon"></i>Unhide
                    </a>
                    <span v-else-if="isUnhiding">Unhiding...</span>
                    <a v-if="(networksById[message.platform].name == 'LinkedIn' && !_is(message, 'directMessage')) || (networksById[message.platform].name == 'Facebook' && !_is(message, 'directMessage')) || (networksById[message.platform].name == 'Instagram' && !_is(message, 'directMessage') && !_is(message, 'mention'))" @click="deleteComment(message, networksById[message.platform].name, 'message', $event)" class="reply">
                      <i class="delete icon"></i> Delete
                    </a>
                    <a v-if="(networksById[message.platform].name == 'Twitter' && !checkTweetIsLiked(message) && !_is(message, 'directMessage'))&& !isLikingTwitter" @click="likeTweet(message, networksById[message.platform].name, 'message', $event)" class="like">
                      <i class="like icon"></i> Like
                    </a>
                    <span v-else-if="isLikingTwitter">Liking...</span>
                    <a v-if="(networksById[message.platform].name == 'Twitter' && checkTweetIsLiked(message) && !_is(message, 'directMessage'))&& !isUnlikingTwitter" @click="undoLikeTweet(message, networksById[message.platform].name, 'message', $event)" class="like active">
                      <i class="like icon"></i> Liked
                    </a>
                    <span v-else-if="isUnlikingTwitter">Unliking...</span>
                    <a v-if="(networksById[message.platform].name == 'Twitter' && !checkTweetIsReTweeted(message) && !_is(message, 'directMessage'))" @click="reTweet(message, networksById[message.platform].name, 'message', $event)" class="retweet">
                      <i class="retweet icon"></i> Retweet
                    </a>
                    <a v-if="(networksById[message.platform].name == 'Twitter' && checkTweetIsReTweeted(message) &&  !_is(message, 'directMessage'))" @click="undoReTweet(message, networksById[message.platform].name, 'message', $event)" class="retweet active">
                      <i style="color: #78CBEF;" class="retweet icon"></i> Undo Retweet
                    </a>
                    <a v-if="(networksById[message.platform].name == 'Twitter' && !_is(message, 'directMessage'))" :href="'https://twitter.com/' + workspaceAccountsById[message.page].id + '/statuses/' + message.id" target="_blank" class="reply">
                      <i  class="linkify icon"></i>Open in Twitter
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        <div v-on:click.stop  v-if="modalInside" style="background: #f5f5f5;  border-color: #f0f0f0;" class="ui basic attached small segment"> 
          <i style="color: #e5e5e5;margin-right:8px;" class="tags icon"></i>
            <span class="notag" style="cursor:pointer;" @click="tagSelector = true;" v-if="!message.tags || (message.tags && !message.tags.length)">Let's add a tag to conversation!</span>
          

            <span v-show="message.tags && message.tags.length">
              <div v-for="tag in filteredMessageTags(message.tags)" :key="tag._id" :class="setTagColor(tagsById[tag._id])"  class="ui small label" :style="{'background': tag.color}">
              {{tag.name}}
              <i v-show="tag.canRemove" @click="removeFromTags($event, tag._id, message)" class="delete icon"></i>
              </div>
            </span>  

            <div style="background: transparent; float:right;" class="ui small label">          
                <a v-if="currentTags.length" @click="tagSelector = true;">ADD TAG</a>
            </div>        
          </div>
          <div v-on:click.stop  v-if="tagSelector" style="background: #f5f5f5;  border-color: #f0f0f0; min-height: 48px;" class="ui basic attached small segment"> 

            <div v-if="defaultFilteredTags() && defaultFilteredTags().length > 5" style="margin-bottom: 1rem;" class="ui mini fluid input">
                      <input style="border: none;" v-model="searchTags" type="text" placeholder="Search...">
                    </div>
            
            <div style="display: inline-block; width:75%;">
                <div v-for="tag in defaultFilteredTags()" :key="tag._id" :style="{'margin-bottom': (tagsByTypeName.DefaultMessageTag && currentWorkspace.userTags && tagsByTypeName['DefaultMessageTag'].length + currentWorkspace.userTags.length > 7) ? '5px':'0px'}" data-aos="fade" :class="setTagColor(tag)" class="ui small label">
                <a @click="addIntoTags($event, tag, message)" >{{tag.name}}</a>
              </div>  
                 <div v-for="tag in filteredMessageTagsCreatedByUser(currentWorkspace.userTags)" :key="tag._id"  :style="{'background': tag.color, 'margin-bottom': (currentWorkspace.userTags && currentWorkspace.userTags.length > 7) ? '5px':'0px'}"  data-aos="fade" class="ui small label">
                <a @click="addIntoTags($event, tag, message)" >{{tag.name}}</a>
              </div> 
            </div>
            <div style="display: inline-block; float:right; width:25%;">       
              <div style="background: transparent;float:right;" class="ui small label">          
                <a @click="tagSelector = false" >
                  <i style="margin-top: -3px;" class="angle up large icon"></i>
                </a>
              </div> 
              <div style="background: transparent;float:right;" class="ui small label">          
              <a @click="setCreateTag(true)">CREATE NEW TAG</a>
            </div>   
            </div>            
          </div>


<!--           <div v-on:click.stop  v-if="show.seeAllMessages" style="background: #fbfbfb; border-color: #fbfbfb; " class="ui basic attached segment  center aligned">
          <div @click="previous()" class="ui icon label" style="position:absolute;z-index: 99999;left: 38%;top: 7px; border-radius: 5px; color: #bbb; font-weight: 400; background: transparent;   cursor:pointer"> <i class="long arrow alternate up icon"></i> See previous messages</div>
          </div> -->
          <div v-bind:class="{ loading: loading }" v-if="modalInside" v-on:click.stop :style="(message.replies.length) ? 'padding-top:0;' : ''"   style="background: #fbfbfb; border-color: #f0f0f0; border-radius: 0 0 5px 5px;" class="ui basic attached segment">

            <div v-if="scrolled" style="background: linear-gradient(to top, rgba(255,0,0,0), rgba(0,0,0,0.05));; height: 15px; top:0; right:0; left:0; position: absolute; z-index: 9999;"></div>

            <div v-if="!show.replies" style="position: absolute; z-index:9999999; left:0; right:0; top:0; bottom:0; background: rgba(255,255,255)">
              <div data-aos="zoom-in" style="height:100%;" class="ui grid centered middle aligned stackable">
                  <div class="six wide computer sixteen wide mobile column">
                      <div class="ui basic segment center aligned">
                      <div style="padding:0;" class="ui basic segment padded">
                      </div>
                      <div style="padding:0; color: #666;" class="ui basic segment">
                        <div class="loader-inner ball-beat"><div></div><div></div><div></div></div>
                      </div>
                      </div>
                  </div>
              </div>
            </div>


<!--             <div v-if="networksById[message.platform].name == 'Instagram' && _is(message, 'directMessage')" style="background: rgba(255,255,255, 0.75);  position: absolute; z-index: 999999; top:0; left:0; right:0; bottom: 0; display: flex; align-content: center; align-items: center; justify-content: center;">
              <p style="color: rgba(0,0,0,0.58)">Insragram API do not support IG DM Reply for now.</p>
            </div> -->
            

            <div v-if="message.replies.length" v-bind:style="{ visibility: modalInIn }" id="overflow" style="margin:0; padding-top: 1rem;" class="ui feed">
            
              <div v-show="message.replies.length" v-for="reply in message.replies"  :key="reply._id" @mouseover="meta = reply._id" class="event"   >
                <div class="label">
                  <img :src="func.replaceImg(reply.from.avatar)" @error="reply.from.avatar = (accountsByPId[reply.from.id]) ? accountsByPId[reply.from.id].avatar :  '/img/avatar/roboto/128/latin_'+ func.turkishToEnglish(reply.from.name).charAt(0).toLowerCase() +'.png'">
                </div>
                <div :style="(networksById[message.platform].name == 'Email') ? 'overflow: auto;' :''" style="margin-top: 0;" class="content">
                  <div class="summary">
                    <a>{{reply.from.name}}</a>
                    <div class="date">{{func.since(reply.createdAt)}} ago</div>
                    <div v-if="reply.repliedBy && reply.repliedBy.name && reply.repliedBy.name.length" class="date">Replied by {{reply.repliedBy.name}}</div><div v-if="reply.tags && reply.tags.includes('63415d3574fd5cb1a1176add')" class="date">· Seen
                    </div>
<!--                     <div class="date">
                      <i style="color: #bbb;" class="tags icon"></i>
                    </div> -->
                  </div>

                    <div  :style="{ opacity: (_is(reply, 'hidden') || _is(reply, 'deleted')) ? '.5' : '1' }" class="extra text">
                    <span :class="(accountsByPId[reply.from.id] || accountsById[reply.from.id]) ? 'messageBlock2' : 'messageBlock3'" v-if="reply.text && networksById[message.platform].name != 'Gmail' && networksById[message.platform].name != 'Email'">
                      <span style="white-space: pre-wrap;">{{reply.text}}</span>  
                      </span>
                      <span style="display: block;" v-if="reply.urls">
                        <a style="margin-top: 1rem;" target="_blank" class="ui icon small label" v-for="url in reply.urls" :key="url" :href="url"> <i class="external alternate icon"></i>{{ url }} </a>
                      </span>
                      <span v-if="reply.text && networksById[message.platform].name == 'Gmail' || reply.text && networksById[message.platform].name == 'Email'">
                        <span>{{reply.text}}</span>
                        <span>{{reply._id}}</span>
                        <iframe :src="'/emailrender?messageId=' + reply._id" width="100%" height="100%" frameborder="0"></iframe>
                      </span>                  


                    <div v-if="networksById[message.platform].name == 'Gmail' && reply.attachments && reply.attachments.length"  class="ui basic segment">
                      <h3>Attachments</h3>
                        <a v-for="file in reply.attachments" :key="file.name" style="display:block; margin-bottom: 5px;" :href="'https://api.juphy.com/gmail/messages/' + reply._id +'/attachment/' + file.id + '.download?accessToken=' + getJwt" class="ui label">
                            <i class="download icon"></i> {{file.name}}
                        </a>
                    </div>

                    </div>


                    <div v-if="reply && reply.attachments" class="extra images">
                      <a v-for="(attachment , index) in reply.attachments" :key="`${index}`" target="_blank" :href="attachment.src"> 
                        <span v-if="attachment.format && attachment.format == 'video'">
                          <video  width="200" controls>
                            <source :src="attachment.src" type="video/mp4">
                            <source :src="attachment.src" type="video/ogg">
                          </video>
                        </span>

                        <span v-if="attachment.format && attachment.format == 'photo'">
                            <img style="background: #fff;padding: 3px;border: 1px solid #eee;border-radius: 2px;" :src="attachment.src">
                        </span>

                        <span v-if="attachment.format && attachment.format == 'image'">
                            <img style="background: #fff;padding: 3px;border: 1px solid #eee;border-radius: 2px;" :src="attachment.src">
                        </span>

                        <span v-if="attachment.format && attachment.format == 'url'">
                          <a target="_blank" :href="attachment.src">{{attachment.src}}</a>
                        </span>

                        <span v-if="!attachment.format">
                            <img style="background: #fff;padding: 3px;border: 1px solid #eee;border-radius: 2px;" :src="attachment.src">
                        </span>
                      </a>
                    </div>

                  <div v-if="_is(reply, 'deleted')" class="meta">
                    <span style="padding-left: 4px;" class="ui red mini label">Deleted</span>
                  </div>

                  <div v-if="!_is(message, 'directMessage') && (networksById[reply.platform].name === 'Facebook' ||networksById[reply.platform].name === 'Instagram')" style="display: block;" class="meta">
                    <div v-for="tag in filteredMessageTags(reply.tags)" :key="tag._id" :class="setTagColor(tagsById[tag._id])"  class="ui mini label" :style="{'background': tag.color}">
                    {{tag.name}}
                    <i v-show="tag.canRemove" @click="removeFromTagsReply($event, tag._id, reply)" class="delete icon"></i>
                    </div>
                  </div>

                  <div v-if="!_is(reply, 'deleted') && getRole.name == 'Admin' || getRole.name == 'Moderator'" v-bind:style="{visibility: (meta == reply._id)? 'visible':'hidden'}"  class="meta">
                    <a v-if="!_is(reply, 'hidden') && !networksById[reply.platform].name == 'Shopify'" @click="updateReplyTo(reply.from.name, reply._id, reply.from.avatar, reply.text, reply, 'reply')" class="reply">
                      <i class="reply icon"></i>Reply
                    </a>
                    <a v-if="!_is(reply, 'hidden') && reply.from.name == 'assistant'" @click="openRetrainModal(reply,message)" style="visibility: visible;" class="reply">
                      <i class="cog icon"></i>Retrain
                    </a>
                    <a v-if="!_is(reply, 'directMessage') && (networksById[reply.platform].name === 'Facebook' ||networksById[reply.platform].name === 'Instagram')" @click="openReplyTags(reply)" class="reply">
                      <i class="tags icon"></i>Add Tag
                    </a>
                    <a v-if="(networksById[reply.platform].name == 'Facebook' && !checkFacebookCommentIsLiked(reply) && !_is(reply, 'directMessage'))" @click="likeFacebookComment(reply, networksById[reply.platform].name, 'reply', $event)" class="like">
                      <i class="like icon"></i> Like
                    </a>
                    <a v-if="(networksById[reply.platform].name == 'Facebook' && checkFacebookCommentIsLiked(reply) && !_is(reply, 'directMessage'))" @click="undoLikeFacebookComment(reply, networksById[reply.platform].name, 'reply', $event)" class="like active">
                      <i class="like icon"></i> Liked
                    </a>

                    <a v-if="(networksById[reply.platform].name == 'Facebook' && !accountsByPId[reply.from.id] && !_is(reply, 'directMessage') && !_is(reply, 'hidden')) || (networksById[reply.platform].name == 'Instagram' && !_is(reply, 'directMessage') && !_is(reply, 'hidden') && !_is(reply, 'mention')) || (networksById[message.platform].name == 'Youtube' && !_is(reply, 'hidden'))" @click="hideComment(reply._id, networksById[reply.platform].name, 'reply', $event, reply)" class="reply">
                      <i class="hide icon"></i>Hide
                    </a>

                    <a v-if="networksById[reply.platform].name != 'Twitter' && !accountsByPId[reply.from.id] && _is(reply, 'hidden') || (networksById[reply.platform].name == 'Youtube' && _is(reply, 'hidden'))" @click="unHideComment(reply._id, networksById[reply.platform].name, 'reply', $event, reply)" class="reply">
                      <i class="unhide icon"></i>Unhide
                    </a>

                    <a v-if="(networksById[reply.platform].name == 'Trust Pilot' && !_is(reply, 'directMessage')) || (networksById[reply.platform].name == 'LinkedIn' && !_is(reply, 'directMessage')) || (networksById[reply.platform].name == 'Facebook' && !_is(reply, 'directMessage')) || networksById[reply.platform].name == 'Google My Business' || (networksById[reply.platform].name == 'Instagram' && !_is(reply, 'directMessage') && !_is(reply, 'mention'))" @click="deleteComment(reply, networksById[reply.platform].name, 'reply', $event)" class="reply">
                      <i class="delete icon"></i>Delete
                    </a>

                    <a v-if="(networksById[reply.platform].name == 'Twitter' && !checkTweetIsLiked(reply) && !_is(reply, 'directMessage'))" @click="likeTweet(reply, networksById[reply.platform].name, 'reply', $event)" class="like">
                      <i class="like icon"></i> Like
                    </a>
                    <a v-if="(networksById[reply.platform].name == 'Twitter' && checkTweetIsLiked(reply) && !_is(reply, 'directMessage'))" @click="undoLikeTweet(reply, networksById[reply.platform].name, 'reply', $event)" class="like active">
                      <i class="like icon"></i> Liked
                    </a>
                    <a v-if="(networksById[reply.platform].name == 'Twitter' && !checkTweetIsReTweeted(reply) && !_is(reply, 'directMessage'))" @click="reTweet(reply, networksById[reply.platform].name, 'reply', $event)" class="retweet">
                      <i class="retweet icon"></i> Retweet
                    </a>
                    <a v-if="(networksById[reply.platform].name == 'Twitter' && checkTweetIsReTweeted(reply) &&  !_is(reply, 'directMessage'))" @click="undoReTweet(reply, networksById[reply.platform].name, 'reply', $event)" class="retweet active">
                      <i style="color: #78CBEF;" class="retweet icon"></i> Undo Retweet
                    </a>
                    <a v-if="(networksById[reply.platform].name == 'Twitter' && !_is(reply, 'directMessage'))" :href="'https://twitter.com/' + workspaceAccountsById[message.page].id + '/statuses/' + reply.id" target="_blank" class="reply">
                      <i  class="linkify icon"></i>Open in Twitter
                    </a>
                  </div>

                  <div v-show="reply.tagsOpened" class="ui basic segment">
                    <h4>Tags selection</h4>

                    <div style="display: inline-block; width:75%;">
                      <div v-for="tag in defaultFilteredTags()" :key="tag._id" :style="{'margin-bottom': (tagsByTypeName.DefaultMessageTag && currentWorkspace.userTags && tagsByTypeName['DefaultMessageTag'].length + currentWorkspace.userTags.length > 7) ? '5px':'0px'}" data-aos="fade" :class="setTagColor(tag)" class="ui tiny label">
                      <a @click="addIntoTagsReply($event, tag, reply)" >{{tag.name}}</a>
                    </div>  
                      <div v-for="tag in filteredMessageTagsCreatedByUser(currentWorkspace.userTags)" :key="tag._id"  :style="{'background': tag.color, 'margin-bottom': (currentWorkspace.userTags && currentWorkspace.userTags.length > 7) ? '5px':'0px'}"  data-aos="fade" class="ui tiny label">
                      <a @click="addIntoTagsReply($event, tag, reply)" >{{tag.name}}</a>
                    </div> 
                  </div>
                  </div>

                </div>
              </div>
            </div>

            


        <!-- v-if="getRole.name == 'Admin' || getRole.name == 'Moderator' || getRole.name == 'Admin' && !_is(message, 'hashtag')" -->
        <div v-if="networksById[message.platform].name !== 'Shopify'" class="ui basic segment replyWrapper" style="padding-top: 8px; background: #ffffff;  border-radius:5px;">

          <div v-if="takeoverChecker && takeover.state">
              <div class="takeover" :class="loadTakeoverBlur + ' ' + loadTakeoverBlurData" >
                <div class="ui teal image label pulseMe">
                  <img :src="'https://www.gravatar.com/avatar/' + func.md5(matchedViewer.user.email) + '?d=monsterid'">
                        {{matchedViewer.user.name}}
                        <div class="detail">Viewing</div>
                </div>
                <div @click="focusNote()" class="ui tiny icon button">Team Chat</div>
                <div @click="takeover.state = false" class="ui tiny button">Join Conversation</div>
              </div>
            </div>
            
<!--           <div v-if="agentTakeoverChecker && agentTakeover.state">
              <div class="takeover" :class="loadTakeoverBlur + ' ' + loadTakeoverBlurData" >
                <div @click="agentTookover()" class="ui tiny button">Join Conversation</div>
              </div>
            </div> -->


          <div v-if="(networksById[message.platform].name == 'Google Play' || networksById[message.platform].name == 'Google My Business') && message.lastReply && message.replies && message.replies.length && !_is(message.replies[message.replies.length-1], 'deleted')" style="background: rgba(255,255,255, 0.75);  position: absolute; z-index: 999999; top:0; left:0; right:0; bottom: 0; display: flex; align-content: center; align-items: center; justify-content: center;">
              <p style="color: rgba(0,0,0,0.58)">You cannot send more than one reply for {{networksById[message.platform].name}}.</p>
            </div>

<!--           <div v-if="networksById[message.platform].name == 'Shopify' && message.lastReply && message.replies && message.replies.length && !_is(message.replies[message.replies.length-1], 'deleted')" style="background: rgba(255,255,255, 0.75);  position: absolute; z-index: 999999; top:0; left:0; right:0; bottom: 0; display: flex; align-content: center; align-items: center; justify-content: center;">
              <p style="color: rgba(0,0,0,0.58)">You cannot send more than one reply for {{networksById[message.platform].name}}.</p>
            </div> -->


            <div class="ui form">
                <div  class="inline field">
                  <label v-show="replyTo.type != 'commentPrivately'" data-tooltip="Reply to" data-inverted="" style="vertical-align: middle;margin-right:3px;color:#999;"> <i class="reply icon"></i> </label>
                  <div v-show="replyTo.type == 'commentPrivately'" style="display: inline-block; padding: 5px 10px; margin-right: 5px; vertical-align: middle;" class="ui blue message">
                  <i class="facebook messenger icon"></i>Replying comment privately as a direct message
                  </div>
                  <span v-show="replyTo.type == 'commentPrivately'" style="vertical-align: middle;color:#555555;border: none; font-weight:bold; padding-right: 5px; padding-left:0;" > to: </span>
                  <img style="background: #eeeeee; width: 19px; margin-right: 2px; border-radius: 15px; vertical-align: middle;" :src="replyTo.avatar" @error="throwImgError($event, {from : { name: replyTo.name }})" alt="">
                  <span style="vertical-align: middle;color:#555555;border: none; font-weight:bold; padding-right: 5px; padding-left:0;" > {{replyTo.name}} </span>
                  <span v-show="replyTo.type != 'commentPrivately'" style="vertical-align: middle;color: #999;font-style: italic;font-size: 12px;display: inline-block;"> {{(replyTo.text.length > 60 ) ? replyTo.text.substring(0, 60) + '...' : replyTo.text }}  </span>
                </div>
                <div style="margin-bottom: 1rem;" class="field">


                  <audio id="voiceRecordElement" style="display: none;" controls>
                    <source src="https://www.w3schools.com/tags/horse.mp3" type="audio/mpeg">
                    Your browser does not support the audio element.
                  </audio>

                    <quill-editor
                      v-if="networksById[message.platform].name == 'Gmail'"
                      ref="myQuillEditor"
                      v-model="replyModal.text"
                      :options="{
                        modules: {
                          clipboard: {
                              matchVisual: false
                          }
                        }
                      }"
                      @blur="onEditorBlur($event)"
                      @focus="onEditorFocus($event)"
                      @ready="onEditorReady($event)"
                    />
                    
                  <textarea v-show="networksById[message.platform].name != 'Gmail'" ref="mainTextarea" v-model="replyModal.text" id="replyBox" placeholder="Type..."   style="border: none; padding:0; color: #757575;"  rows="8"></textarea>




               </div>

                <div v-if="show.twitterDm"  class="field">
                 <div style="margin-bottom: 20px; margin-left: -1rem;margin-right: -1rem;border-bottom: 1px solid #f5f5f5;" class="ui basic segment">
                  <div class="ui  fluid circular button" style="border: 1px solid rgb(29, 161, 242); color: rgb(29, 161, 242); background: transparent;" >
                    <i class="ui envelope icon"></i> Send us a private message
                  </div>
                 </div>
               </div>

               <div v-if="attachmentPreview.length" data-aos="fade"  class="field">
                    <div class="ui small image">
                      <div v-if="loader.sendingFile" class="ui active inverted dimmer">
                        <div class="ui indeterminate text loader">Sending</div>
                      </div>
                      <a v-if="!loader.sendingFile" @click="removeAttachment()" class="ui right corner  label">
                        <i class="trash icon"></i>
                      </a>
                      <img :src="attachmentPreview">
                    </div>
               </div>

               <div v-if="attachmentPreviews.length" data-aos="fade"  class="field">
                    <div v-for="attachment in attachmentPreviews" :key="attachment" class="ui small image">
                      <div v-if="loader.sendingFile" class="ui active inverted dimmer">
                        <div class="ui indeterminate text loader">Sending</div>
                      </div>
                      <a v-if="!loader.sendingFile" @click="removeAttachment()" class="ui right corner  label">
                        <i class="trash icon"></i>
                      </a>
                      <img :src="attachment">
                    </div>
               </div>

               <div v-if="show.emojis" data-aos="fade"  class="field">
                 <div style="overflow-y: scroll;height: 225px;margin-bottom: 20px;border-top: 1px solid #f5f5f5;margin-left: -1rem;margin-right: -1rem;border-bottom: 1px solid #f5f5f5;" class="ui basic segment">
                  <h5 v-show="recentEmojis.length">Frequently used</h5>
                    <span v-show="recentEmojis.length" style="cursor:pointer; padding-bottom: 10px;padding-right: 15px;font-size: 22px; display: inline-block;" v-for="emoji in recentEmojis" :key="emoji.codes" @click="addEmoji(emoji)">{{emoji.char}}</span>
                    <input style="border:none; margin-left: -1rem; margin-bottom: 0.5rem;" v-model="searchEmojis" type="text" placeholder="Search... hand, love, star..."/>
                    <span style="cursor:pointer; padding-bottom: 10px;padding-right: 15px;font-size: 22px; display: inline-block;" v-for="emoji in getEmojis" :key="emoji.no" @click="addEmoji(emoji)">{{emoji.char}}</span>
                 </div>
               </div>
               <div v-if="show.quickReply" data-aos="fade"  class="field">
                 <div :style="(!getCurrentWorkspaceuser().quickReplies || getCurrentWorkspaceuser().quickReplies && !getCurrentWorkspaceuser().quickReplies.length) ? '':'height: 240px;'" style="overflow-y: scroll;margin-bottom: 20px;border-top: 1px solid #f5f5f5;margin-left: -1rem;margin-right: -1rem;border-bottom: 1px solid #f5f5f5;" class="ui basic segment">
                  <div class="ui action input">
                    <textarea style="border:none;" rows="3" v-model="cannedResponse" type="text" placeholder="Search / Create Canned Response"></textarea>
                    <button @click="saveCannedResponse()"  class="ui green button" :disabled="!cannedResponse.length">ADD</button>
                  </div>
                  <div v-if="getCurrentWorkspaceuser().quickReplies && getCurrentWorkspaceuser().quickReplies.length" class="ui selection divided list">
                    <div style="background: transparent;"  v-for="cannedResponse in getCannedResponses" :key="cannedResponse._id" @mouseover="show.hoverResponseId = cannedResponse._id" @mouseleave="show.hoverResponseId = 0" v-on:click.self="setReplyModal(cannedResponse.text)" class="item">
                                  
                      <div v-on:click.self="setReplyModal(cannedResponse.text)" style="position:relative;" class="content">
                        <div v-on:click.self="setReplyModal(cannedResponse.text)" style="line-height: 1.4; padding:5px;" class="description">{{cannedResponse.text}}  <div v-show="cannedResponse._id == show.hoverResponseId"  v-on:click="removeCannedResponse(cannedResponse)" style="background: transparent;" class="ui mini icon button"> <i class="x icon"></i> </div></div>
                                      
                      </div>
                    </div>
                  </div>
                 </div>
               </div>
          </div>
          <div class="ui right floated buttons">
              <button v-if="networksById[message.platform].name == 'Facebook' && _is(message, 'directMessage')" @click="facebookDirectMessageReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span><span v-if="loader.sending">Sending...</span></button>
              <button v-if="networksById[message.platform].name == 'Facebook' && _is(message, 'directMessage')" @click="facebookDirectMessageReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui icon blue button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span><span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Twilio'" @click="twilioReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span><span v-if="loader.sending">Sending...</span></button>
              <button v-if="networksById[message.platform].name == 'Twilio'" @click="twilioReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui icon blue button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span><span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Facebook' && !_is(message, 'directMessage') && replyTo.type != 'commentPrivately'" @click="facebookCommentReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>
              <button v-if="networksById[message.platform].name == 'Facebook' && !_is(message, 'directMessage') && replyTo.type != 'commentPrivately'" @click="facebookCommentReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Facebook' && !_is(message, 'directMessage') && replyTo.type == 'commentPrivately'" @click="facebookCommentReplyPrivately(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending"> <i class="facebook messenger icon"></i>Send</span>   <span v-if="loader.sending">Sending...</span></button>

<button v-if="networksById[message.platform].name == 'Twitter' && !_is(message, 'directMessage') || networksById[message.platform].name == 'Google Play' || networksById[message.platform].name == 'App Store'" class="ui button" style="background: transparent;
border-top: 1px solid #eee;
border-left: 1px solid #eee;
border-bottom: 1px solid #eee;
border-radius: 5px 0 0 5px;">
  <span :style="(networksById[message.platform].name == 'Twitter' && (show.twitterDm && replyModal.text.length > 258 || replyModal.text.length > 280)) || (networksById[message.platform].name == 'Google Play' && replyModal.text.length > 350) ? 'color: #ff0000;' : ''|| (networksById[message.platform].name == 'App Store' && replyModal.text.length > 350) ? 'color: #ff0000;' : ''" >{{replyModal.text.length}}</span>
</button>

<button v-if="networksById[message.platform].name == 'Twitter' && !_is(message, 'directMessage')" class="ui icon button" style="background: #eeeeee;
border-top: 1px solid #eee;
border-left: 1px solid #eee;
border-bottom: 1px solid #eee;">
              <div v-if="networksById[message.platform].name == 'Twitter' && !_is(message, 'directMessage')" @click="(show.twitterDm) ? show.twitterDm = false : show.twitterDm = true" class="ui checkbox">
                <input  type="checkbox" :checked="show.twitterDm">
                <label style="font-weight: normal;">Include DM Button</label>
              </div>
</button>
              <button v-if="networksById[message.platform].name == 'Twitter' && _is(message, 'directMessage')" @click="twitterDM2(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>
              <button v-if="networksById[message.platform].name == 'Twitter' && _is(message, 'directMessage')" @click="twitterDM2(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close </span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Twitter' && !_is(message, 'directMessage')" @click="twitterTweet2(message._id, null)" style="padding: 11px 20px; font-weight:400;" class="ui icon button" :disabled="loader.sending || (show.twitterDm && replyModal.text.length > 258 || replyModal.text.length > 280)"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>
              <button v-if="networksById[message.platform].name == 'Twitter' && !_is(message, 'directMessage')" @click="twitterTweet2(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending || (show.twitterDm && replyModal.text.length > 258 || replyModal.text.length > 280)"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Instagram' && !_is(message, 'directMessage') && _is(message, 'ads')" @click="instagramAdReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>
              <button v-if="networksById[message.platform].name == 'Instagram' && !_is(message, 'directMessage') && _is(message, 'ads')" @click="instagramAdReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Instagram' && !_is(message, 'directMessage') && !_is(message, 'mention') && !_is(message, 'ads')" @click="instagramCommentReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>
              <button v-if="networksById[message.platform].name == 'Instagram' && !_is(message, 'directMessage') && !_is(message, 'mention') && !_is(message, 'ads')" @click="instagramCommentReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Instagram' && _is(message, 'directMessage') && !_is(message, 'mention') && !_is(message, 'ads')" @click="instagramDirectMessageReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>
              <button v-if="networksById[message.platform].name == 'Instagram' && _is(message, 'directMessage') && !_is(message, 'mention') && !_is(message, 'ads')" @click="instagramDirectMessageReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Instagram' && !_is(message, 'directMessage') && _is(message, 'mention')" @click="instagramMentionReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>
              <button v-if="networksById[message.platform].name == 'Instagram' && !_is(message, 'directMessage') && _is(message, 'mention')" @click="instagramMentionReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close </span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Youtube' && !_is(message, 'directMessage')" @click="youtubeReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>
              <button v-if="networksById[message.platform].name == 'Youtube' && !_is(message, 'directMessage')" @click="youtubeReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>
              
              <button v-if="networksById[message.platform].name == 'Google Play' && !message.lastReply" @click="playStoreReviewReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending || replyModal.text.length > 350"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Google Play' && !message.lastReply" @click="playStoreReviewReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending || replyModal.text.length > 350"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'App Store' " @click="appStoreReviewReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending || replyModal.text.length > 350"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'App Store' && !message.lastReply" @click="appStoreReviewReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending || replyModal.text.length > 350"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

            <!--   Google My Business   -->
              <button v-if="networksById[message.platform].name == 'Google My Business'" @click="googleMyBusinessReviewReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Google My Business'" @click="googleMyBusinessReviewReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Gmail'" @click="gmailReply(message._id, false)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Gmail'" @click="gmailReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Email'" @click="emailReply(message._id, false)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Email'" @click="emailReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'LinkedIn'" @click="linkedInReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'LinkedIn'" @click="linkedInReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'WhatsApp'" @click="whatsAppReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'WhatsApp'" @click="whatsAppReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Trust Pilot'" @click="truspilotReviewReply(message._id, null)" style="padding: 11px 20px; font-weight:400; " class="ui icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send </span>   <span v-if="loader.sending">Sending...</span></button>

              <button v-if="networksById[message.platform].name == 'Trust Pilot'" @click="truspilotReviewReply(message._id, true)" style="padding: 11px 20px; font-weight:400; " class="ui blue icon button" :disabled="loader.sending"><span v-if="!loader.sending">Send + Close</span>   <span v-if="loader.sending">Sending...</span></button>
              
          </div>
          <div class="ui icon buttons">
              <!-- <button class="ui basic large button" disabled><i class="image outline icon"></i></button> -->
              <button data-tooltip="Emoji" data-inverted="" @click="showEmojis()" class="ui basic button"><i class="smile outline icon"  ></i></button>
              <button data-tooltip="Canned Responses" data-inverted=""  @click="openCannedResponse()" class="ui basic button"><i class="clock icon"  ></i> Quick Reply</button>
             


<button v-if="(networksById[message.platform].name == 'Facebook' ) && _is(message, 'directMessage')" @click="uploadMultiple" class="ui basic button"><i class="paperclip icon"  ></i> Upload</button>
<button v-if="(networksById[message.platform].name == 'Twitter' )" @click="upload" class="ui basic button"><i class="paperclip icon"  ></i> Upload</button>

<!-- <button v-if="(networksById[message.platform].name == 'Instagram' )" @click="uploadMultiple" class="ui basic button"><i class="paperclip icon"  ></i> Upload</button> -->


<button v-if="(networksById[message.platform].name == 'Instagram' )" id="recordButton" @click="record('start')" class="ui basic button"><i class="microphone icon"  ></i> Record Voice</button>

<button v-if="(networksById[message.platform].name == 'Instagram' )" style="visibility: hidden;" id="stopButton" @click="record('stop')" class="ui basic button"><i class="stop icon"  ></i> Stop</button>

<input id="upload" class="ui basic button" type="file" @change="onFileChange($event)" multiple style="display: none;">

<input id="upload2" class="ui basic button" type="file" @change="onFileChange2($event)" style="display: none;">
  
            

     


              <!-- <button class="ui basic button" disabled>Quick Reply</button> -->
          </div>
        </div>
          </div>
        </div>
        </div>
      <div class="four wide column">
                   <a @click="openSocial(message)"> <div v-if="message.page"  style="background: #f5f5f5;cursor:pointer; border-radius: 5px;  border-color: #f0f0f0;" class="ui basic segment">
            
                <img class="ui avatar image" :src="workspaceAccountsById[message.page].avatar">
                 <span style="font-weight: bold; vertical-align: middle;">{{workspaceAccountsById[message.page].name}}</span>

              
            </div></a>
    
            <div style="background: #f5f5f5; border-radius: 5px;  border-color: #f0f0f0;"  class="ui basic segment">
                <button @click="replySuggestion() " :disabled="loader.aiGenerating" :class="(loader.aiGenerating) ? 'ui black fluid loading button' : 'ui black fluid button'">🔮 Get a Reply Suggestion</button>
                <p v-if="suggestedReply.length" id="suggestedReply" @click="replyModal.text = suggestedReply" style="margin-top: 1rem; font-family: Georgia; font-style: italic;">{{ suggestedReply }}</p>
            </div>
        <div style="border-radius: 5px 5px 0 0; border-bottom:1px solid #eee; background: #f5f5f5; border-color: #f0f0f0;  z-index:9999; margin-bottom:0; padding:0;" class="ui basic segment">
          <div v-show="message.users && message.users.length" style="margin-top:0; margin-bottom:0;" class="ui basic segment">
            <h5 class="ui header">Assigned</h5>
              <div class="ui middle aligned animated selection list">
                <div @click="deleteAssignedTeammate(user)" title="Remove from the assigned list" @mouseover="show.removeAssigned = true" @mouseleave="show.removeAssigned = false" v-for="user in message.users" :key="user._id"  class="item">
                  <img class="ui avatar image" :src="'https://www.gravatar.com/avatar/' + func.md5(user.email) + '?d=monsterid'">
                  <div class="content">
                    <div class="header">{{user.name}}</div>
                  </div>
                    <div v-show="show.removeAssigned" class="right floated content">
                      <div style="background: transparent;" class="ui mini icon button"> <i class="minus icon"></i> </div>
                    </div>                  
                </div>
              </div>
          </div>
          <button @click="(show.teamList) ? show.teamList = false : show.teamList = true" :style="(message.users && message.users.length) ? 'border-radius: 0;':'border-radius:  5px 5px 0 0;'" style="text-align:left;" class="ui right labeled fluid icon button">
            <i :class="(show.teamList) ? 'down':'right'" class="chevron icon"></i>
            <span>Assign to</span>
          </button>

            <div v-if="show.teamList" style="margin-top:0; background: #ffffff;" class="ui basic segment">
              <div class="ui middle aligned animated selection list">
                <div :style="(isAssigned(teammate)? 'opacity: 0.2':'')" :class="(isAssigned(teammate)) ? 'disabled':''"  @click="assignTeammate(teammate)" @mouseover="show.setAssigned = true" @mouseleave="show.setAssigned = false" v-for="teammate in assignableTeam" :key="teammate._id" class="item">
                  <img class="ui avatar image" :src="'https://www.gravatar.com/avatar/' + func.md5(teammate.user.email) + '?d=monsterid'">
                  <div class="content">
                    <div class="header">{{teammate.user.name}}</div>
                  </div>
                      <div v-show="show.setAssigned && !isAssigned(teammate)" class="right floated content">
                        <div style="background: transparent;" class="ui mini icon button"> <i class="plus icon"></i> </div>
                      </div>
                </div>
              </div>
          </div>

        </div>

        <div style="border-radius: 0 0 5px 5px; background: #f5f5f5; border-color: #f0f0f0; padding:0; z-index:9999;  margin-top:0;" class="ui basic segment">

          <div v-if="matchedViewers.length" style="margin: 0;" class="ui basic segment">
            <h5>Viewing now</h5>
              <div class="ui teal image label pulseMe" :style="(matchedViewers.length) ? 'margin-bottom: 0.5rem;':''" data-aos="zoom-in" v-for="visited in matchedViewers" :key="visited.user._id">
                  <img :src="'https://www.gravatar.com/avatar/' + func.md5(visited.user.email) + '?d=monsterid'">
                        {{visited.user.name}}
                        <div class="detail">Viewing</div>
                </div>
          </div>

          <div id="notesWrapper" v-if="message.notes && message.notes.length" style="max-height:250px; margin-bottom: 0px;background: #fff;border-bottom: 1px solid #eee;" class="ui basic segment notesFlow">
          <div style="margin-bottom: 5px;" data-aos="zoom-in" class="ui threaded comments">
            <div v-for="note in message.notes" :key="note._id" class="comment">
              <div class="content">

                <div style="padding: 0.6rem; background: rgb(255, 246, 225); border-radius: 0.5rem; color: rgba(0,0,0,0.6);" class="text">

                  <div style="display: block; border-bottom: 1px solid rgba(0,0,0,0.05); padding-bottom: 0.2rem; margin-bottom: 0.2rem;">
                  <img style="width: 16px; border-radius: 20px; vertical-align: bottom;" :src="'https://www.gravatar.com/avatar/' + func.md5(note.user.email) + '?d=monsterid'">
                <a style="font-size: 12px;" class="author">{{note.user.name}}</a>
                <div class="metadata">
                  <span style="font-size: 10px;" class="date">{{func.since(note.createdAt)}} ago</span>
                </div>
              </div>
              {{note.text}}

              <span style="display: block;" v-if="note.urls">
                        <a style="margin-top: 1rem;" target="_blank" class="ui icon small label" v-for="url in note.urls" :key="url" :href="url"> <i class="external alternate icon"></i>{{ url }} </a>
                      </span>

                </div>
<!--                 <div v-if="getUser._id == note.user._id" class="actions">
                  <a @click="deleteNote(note._id)" class="delete">Delete</a>
                </div> -->
              </div>
            </div>
          </div>
          </div>

          <div style="padding:7px;" class="ui reply form">
              <div class="field">
                <div :class="(loader.note) ? 'loading' : ''" class="ui icon input">
                  <input id="writeNote" v-on:keyup.enter="createNote()" v-model="note.text" style="border:none; border-radius: 0.5rem;" type="text" placeholder="Add note or team chat...">
                  <span class="ui icon" style="position:absolute;top:21.5%;left:88.2%; z-index:1;margin-right:4px;color:#737373de">
                  <i  @click="createNote()" class="send icon" style="cursor:pointer"></i>
                  <img v-if="writeNotePointer" data-aos="zoom-in" class="writeNotePointer" src="https://juphy.com/wp-content/uploads/2023/02/teamChat2.png" alt="">
                  </span>
                </div>
              </div>
            </div>

        </div>

          <div class="ui fullscreen modal" :class="{ active: retrainModal }">
                  <i class="close icon" @click="closeRetrainModal"></i>
                   <h2 class="ui header">Train Juphychat
                    <div class="sub header">This correction will be applied to any next similiar questions</div>
                   </h2>
                  <div class="content">
                    <div class="ui form">
                      <div class="field">
                        <label>User Question</label>
                         <div class="ui disabled input">
                          <input type="text" v-model="retrainModalQuestion">
                         </div>
                        </div>
                      <div class="field">
                         <label>Revise the answer for future responses.</label>
                         <textarea v-model="retrainModalAnswer" @input="updateCharacterCount" spellcheck="false" maxlength="5000"></textarea>
                         <div class="character-counter">
                             {{ retrainModalAnswerCount }}/1000
                        </div>
                       </div>
                     </div>
                   </div>
                    <div class="actions">
                      <button class="ui positive button" @click="saveRetrainData" :disabled="isShopify">Save</button>
                    </div>
                </div>

        <div style="background: #f5f5f5; border-radius: 5px;  border-color: #f0f0f0;"  class="ui basic segment">
                    <div class="ui form">
                  <div class="field">
                    <input type="text" v-model="contact.email" placeholder="Email">
                  </div>
                  <div class="field">
                    <input type="text" v-model="contact.phone" placeholder="Phone">
                  </div>
                  <div class="field">
                    <button @click="addIntoContacts() " :disabled="(!this.contact.email.length && !this.contact.phone.length)" :class="(loader.addContact) ? 'ui black fluid loading button' : 'ui black fluid button'">Update Contacts</button>
                  </div>
              </div>
            </div>

        <div v-if="message.platform && (networksById[message.platform].name == 'LinkedIn' || networksById[message.platform].name == 'Instagram' || networksById[message.platform].name == 'Facebook') && !_is(message, 'directMessage')" style="background: #f5f5f5; padding:0; border-color: #f0f0f0; border-radius:5px; z-index:9999; overflow-y: auto; height: 200px;" class="ui basic segment">
          <div v-if="!loader.feed" class="ui loading fluid huge icon button"></div>
            <div style="overflow-y: scroll; max-height: 100px; border-radius: 5px 5px 0 0;">
              <a v-if="feed.load && feed.attachments.length && feed.attachments[0].src && !feed.attachments[0].src.match('mp4')"  target="_blank" :href="feed.link">
                <img class="ui fluid image" :src="feed.attachments[0].src" alt="">
              </a>
              <video v-if="feed.load && feed.attachments.length && feed.attachments[0].src && feed.attachments[0].src.match('mp4')" width="100%" controls>
                <source :src="feed.attachments[0].src" type="video/mp4">
              </video>

            </div>
            <div v-if="feed.load && feed.text"  style="margin-top: 0; word-wrap: break-word" class="ui basic segment">
              <p style="color: #666666;"> <span> <a target="_blank" :href="feed.link"> <i class="linkify icon"></i>Go to original post </a> </span><br> {{feed.text}}  </p>
            </div>
            <div v-if="loader.error && loader.feed"  style="margin-top: 0; word-wrap: break-word" class="ui basic segment">
              <p style="color: #666666;">  {{loader.error}}  </p>
            </div>

            <div  v-if="feed.load && !feed.text && feed.link"  style="margin-top: 0; word-wrap: break-word" class="ui basic segment">
              <a target="_blank" :href="feed.link"> <i class="linkify icon"></i>Go to original post </a>
              <!-- <p style="color: #666666;">{{feed.link}}</p> -->
            </div>
        </div>
        <div v-if="message.platform && networksById[message.platform].name == 'Youtube' && !_is(message, 'directMessage')" style="background: #f5f5f5; padding:0; border-color: #f0f0f0; border-radius:5px; z-index:9999;" class="ui basic segment">
            <div style="overflow-y: auto; border-radius: 5px 5px 0 0;">

              <iframe  width="100%" height="315" :src="'https://www.youtube.com/embed/' + message.feed" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

            </div>
        </div>

        </div>
        </div>
        </div>
    </div>
</div>
</div>
</template>


<style scoped>
#overflow {
  overflow-y: auto;
  max-height:400px;
  position: relative;
}
.notesFlow {
    overflow: hidden;
}

.notesFlow:hover {
    overflow-y: scroll;
}

.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow-x: hidden;
   overflow-y: scroll;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow-x: hidden;
   overflow-y: scroll;
}

.ui.fullscreen.modal{
  margin-top:3rem;
  width:85% !important;
}

.character-counter{
  display: flex;
  justify-content: flex-end;
}
.shadow{
   box-shadow: 0px 0px 44px rgba(99, 99, 99, 0.85);
   border: none;
}
.ui.feed > .event > .content .extra.images img {
    width: auto;
    max-width: 15em;
}

.replyWrapper{
  border: 1px solid #f5f5f5 !important;
  transition: .3s;
}

.replyWrapper:hover{
  box-shadow: 2px 2px 4px #ddd;
}
.replyWrapper:focus-within{
  box-shadow: 2px 2px 15px #ddd;
}

span.notag {
   color: rgb(213, 213, 213);;
}

span.notag:hover {
   color: #a5a5a5;
}

.ui.feed.main {
  transition: 0.5s;
  padding: 10px 10px;
  border: 1px solid #f1f1f1;
  border-radius: 5px;
  background: #fff;
}

.ui.feed.main:hover {
  background: #f9fbff;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #e0ebfc;
}

.ui.feed > .event > .label + .content {
  margin: 0.5em 0 0.35714286em 0;
}

.ui.label .detail {
  background: rgba(0, 0, 0, 0.1);
  margin: -0.5833em -0.833em -0.5833em 0.5em;
  padding: 0.5833em 0.833em;
  border-radius: 0 0.28571429rem 0.28571429rem 0;
}

.ui.feed > .event {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0em;
  margin: 0em;
  background: none;
  border-top: none;
}

.ui.feed > .event > .label {
  margin-left: 1.6em;
}

.ui.feed > .event .label {
  border-left: 1px solid rgb(231,231,231);
}

.ui.feed > .event > .label {
  display: block;
  flex: 0 0 auto;
  width: 3em;
  height: auto;
  align-self: stretch;
  text-align: left;
}

.ui.feed > .event > .content {
  word-wrap: anywhere;
}

.ui.feed > .event > .label > img,
.ui.feed > .event > .label > .icon {
  background-color:#eeeeee;
  border-radius: 500rem;
  color: #ffffff;
  width: 3rem;
  height: 3rem;
  line-height: 1.5;
  left: -1.6rem;
  opacity: 1;
  position: relative;
}

.ui.feed > .event > .label img {
  width: 100%;
  height: auto;
  border-radius: 500rem;
}

.ui.feed > .event > .content .extra.text {
  max-width: none;
}

.ui.feed > .event:last-child .label {
  border-left-color: transparent;
}

.ui.opened_message.menu .item::before {
  background: #f0f0f0;
}


.status span:hover{
  cursor: pointer;
}
.loadingDots:after {
  content: ' .';
  animation: dots 1s steps(5, end) infinite;}

  .messageBlock1{
    background: #2185d0;
    padding: .6rem 1rem;
    border-radius: .4rem;
    color: #eee;
    display: inline-block;
    margin: 0rem 0rem;
  }

  .messageBlock2{
    background: #e6f4ff;
    padding: .5rem 1rem;
    border-radius: .4rem;
    color: #506491;
    display: inline-block;
    margin: 0rem 0rem;
  }

    .messageBlock3{
    background: #eee;
    padding: .5rem 1rem;
    border-radius: .4rem;
    color: #444;
    display: inline-block;
    margin: 0rem 0rem;
  }


@keyframes dots {
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  40% {
    color: black;
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  60% {
    text-shadow:
      .25em 0 0 black,
      .5em 0 0 rgba(0,0,0,0);}
  80%, 100% {
    text-shadow:
      .25em 0 0 black,
      .5em 0 0 black;}}

.pending {font-size: 10px;color: rgb(255, 172, 5);margin-left: 10px;border: 1px solid rgb(255, 172, 5);background: rgb(255, 238, 204) none repeat scroll 0% 0%;padding: 4px 7px;border-radius: 3px;}
.solved{font-size: 10px;color: rgb(77, 200, 83);margin-left: 10px;border: 1px solid rgb(77, 200, 83);background: rgb(205, 255, 204) none repeat scroll 0% 0%;padding: 4px 7px;border-radius: 3px;}

.ui.image.label.pulseMe {
  width: auto !important;
  margin-top: 0;
  margin-bottom: 0;
  max-width: 9999px;
  vertical-align: baseline;
  text-transform: none;
  background: #f0f0f0;
  background-color: rgb(240, 240, 240);
  background-image: none;
  padding: .5833em .833em .5833em .5em !important;
  border-radius: .28571429rem;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 0;
}
.ui.image.label.pulseMe img {
  margin: -.5833em .5em -.5833em -.5em;
  vertical-align: top;
}

.pulseMe {
  background: #d1ffd1;
  color: #5abf5a;
  transition: 0.5s;
  -webkit-animation: pulse 1.8s infinite;
  animation: pulse 1.8s infinite;
}


@-webkit-keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(31, 35, 32, 0.5);
  }
  65% {
    box-shadow: 0 0 0 7px rgba(249, 115, 82, 0);
  }
  to {
    box-shadow: 0 0 0 0 rgba(249, 115, 82, 0);
  }
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(31, 35, 32, 0.5);;
  }
  65% {
    box-shadow: 0 0 0 7px rgba(249, 115, 82, 0);
  }
  to {
    box-shadow: 0 0 0 0 rgba(249, 115, 82, 0);
  }
}

#suggestedReply:hover{
  cursor: pointer;
  text-decoration: underline;
}

.takeoverBlur {
  backdrop-filter: blur(50px) opacity(1) !important;
}

.takeover {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  top: 0rem;
  right: 0rem;
  left: 0rem;
  bottom: 0rem;
  position: absolute;
  z-index: 999999;
  border-radius: 0.3rem 0.3rem 0.3rem 0.3rem;
  text-align: center;
  color: #f1f1f1;
  transition: backdrop-filter 1.8s;
  backdrop-filter: blur(50px) opacity(0);
}


@-webkit-keyframes blackPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.4) inset;
  }
  65% {
    box-shadow: 0 0 10rem rgba(163, 161, 161, 0) inset;
  }
  to {
    box-shadow: 0 0 0 0 rgba(249, 115, 82, 0) inset;
  }
}
@keyframes blackPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.4) inset;
  }
  65% {
    box-shadow: 0 0 10rem rgba(163, 161, 161, 0) inset;
  }
  to {
    box-shadow: 0 0 0 0 rgba(249, 115, 82, 0) inset;
  }
}

.writeNotePointer {
  position: absolute;
  left: -12rem;
  width: 200px;
  z-index: 999999;
  top: 0.8rem;
}

#writeNote:focus + .ui.icon .send.icon{
  color: rgba(0,0,0,.87);
  transition: color .1s ease,border-color .1s ease
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/conversationModal.vue